webpackJsonp([3],{

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        validate: { type: Boolean, default: true },
        vfield: { type: String, default: '' },
        vindex: { type: Number, default: null },
        silent: { type: Boolean, default: false }
    },
    computed: {
        invalid: function invalid() {
            var validator = this.getValidator();
            return validator && validator.$error;
        },
        errorMsg: function errorMsg() {
            var validator = this.getValidator();
            if (!this.silent && validator) {
                if (validator.minLength === false) {
                    return 'Min ' + validator.$params.minLength.min;
                } else if (validator.maxLength === false) {
                    return 'Max ' + validator.$params.maxLength.max;
                } else if (validator.numeric === false) {
                    return 'Numbers only';
                } else if (validator.required === false) {
                    return 'Field is required';
                }
            }

            return null;
        }
    },
    methods: {
        touch: function touch(e) {
            var validator = this.getValidator();
            if (validator) {
                validator.$touch(e);
            }
        },
        getValidator: function getValidator() {
            if (!this.validate || _.isNil(this.$vnode.data.model)) {
                return null;
            }
            var vmodel = this.vfield ? this.vfield.replace('index', this.vindex) : this.$vnode.data.model.expression;
            return _.get(this.$parent.$options.parent.$v, vmodel, null);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            inspections: [],
            inspectionsMeta: {
                total: 0,
                page: 0
            }
        };
    },

    methods: {
        inspectionPath: function inspectionPath(inspection) {
            return 'inspections/' + inspection.id;
        },
        queryInspections: function queryInspections(search, search_include, region_filter, status_filter, count, skip) {
            var callback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};

            var self = this;
            var paramString = '?include=region,status,contact,parcels,inspector&count=' + count + '&page=' + Math.floor(skip / count);

            if (search) {
                if (paramString) {
                    paramString += '&q=';
                } else {
                    paramString += '?q=';
                }
                paramString += encodeURIComponent(search);
            }
            if (search_include) {
                if (paramString) {
                    paramString += '&qi=';
                } else {
                    paramString += '?qi=';
                }
                paramString += encodeURIComponent(search_include);
            }

            if (region_filter) {
                if (paramString) {
                    paramString += '&region_abbr=';
                } else {
                    paramString += '?region_abbr=';
                }
                paramString += encodeURIComponent(region_filter);
            }

            if (status_filter) {
                if (paramString) {
                    paramString += '&status.typename=';
                } else {
                    paramString += '?status.typename=';
                }
                paramString += encodeURIComponent(status_filter);
            }

            self.axios.get('inspections' + paramString).then(function (response) {
                self.inspections = response.data.data;
                self.inspectionsMeta = response.data.meta;

                callback(self.inspections, self.inspectionsMeta);
            });
        },
        createInspection: function createInspection() {
            var _this = this;

            this.working = true;

            var promise = this.axios.post('inspections').then(function (response) {
                _this.$toasted.success('Inspection successfully created!');
                _this.working = false;
                return response;
            }).catch(function (err) {
                console.log(err);
                _this.$toasted.error('Error creating inspection, please contact admin', { duration: 6000 });
                _this.working = false;
            });

            return promise;
        }
    }
});

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_schema_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_js_planner_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_min_css__);

















function isBrowser() {
    return typeof window !== 'undefined';
}

var VueSweetalert2 = {
    install: function install(Vue, options) {
        if (!options) {
            options = { toast: false };
        }

        var _swal = isBrowser() ? __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a : function () {};

        Vue.swal = _swal;

        Object.defineProperty(Vue.prototype, '$swal', {
            get: function get() {
                return _swal;
            }
        });
    }
};

__webpack_require__(468);
__webpack_require__(467);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$schema = __WEBPACK_IMPORTED_MODULE_10__assets_js_schema_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$planner = __WEBPACK_IMPORTED_MODULE_11__assets_js_planner_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_11__assets_js_planner_js__["a" /* default */].init();

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_toasted___default.a, {
    theme: "outline",
    action: {
        text: 'Close',
        onClick: function onClick(e, toastObject) {
            toastObject.goAway(0);
        }
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(832));

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.defaults.baseURL = "https://tree-farm-api.woodscamp.com/v2/";
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.defaults.headers.common.Accept = "application/json";

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    switch (error.response.status) {
        case 401:
            if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].currentRoute !== "login") {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch("auth/logout");
                __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push("/login");
            }
            break;

        case 422:
            _.forOwn(error.response.data.errors, function (value, key) {
                _.each(value, function (err) {
                    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].toasted.error(err);
                });
            });
            break;

        default:
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].toasted.error("An error occured.");
    }

    __WEBPACK_IMPORTED_MODULE_11__assets_js_planner_js__["a" /* default */].busy(false);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.matched.some(function (m) {
        return m.meta.guest;
    })) {
        next();
    } else if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.authenticated) {
        next({ name: "login" });
    } else if (to.meta.roles && to.meta.roles.filter(function (value) {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.roles.indexOf(value) !== -1;
    }).length === 0) {
        next({ name: "inspections" });
    } else {
        next();
    }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch("auth/init");

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(VueSweetalert2);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: "#app",
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
    template: "<App/>",
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_slice__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xmldom__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xmldom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xmldom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_text_encoding__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_text_encoding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_text_encoding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__minipdf_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pako__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pako___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pako__);













if (typeof window == "undefined") {

    var TextEncoder = __WEBPACK_IMPORTED_MODULE_4_text_encoding__["text_encoding"].TextEncoder;

    var TextDecoder = __WEBPACK_IMPORTED_MODULE_4_text_encoding__["text_encoding"].TextDecoder;
}

function pdfform() {

    var assert = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].assert;

    function BytesIO() {
        this.length = 0;

        this.entries = [];
    }

    BytesIO.prototype = {
        write_str: function write_str(s) {
            this.length += s.length;

            assert(typeof s == "string");

            this.entries.push(s);
        },

        write_buf: function write_buf(buf) {
            this.length += buf.length;

            assert(buf instanceof Uint8Array, "Expected a Uint8Array, but got " + buf);

            this.entries.push(buf);
        },

        get_uint8array: function get_uint8array() {
            var res = new Uint8Array(this.length);

            var pos = 0;

            this.entries.forEach(function (e) {
                if (typeof e == "string") {
                    for (var i = 0, slen = e.length; i < slen; i++, pos++) {
                        res[pos] = e.charCodeAt(i);
                    }
                } else {
                    res.set(e, pos);

                    pos += e.length;
                }
            });

            assert(pos === this.length);

            return res;
        },

        position: function position() {
            return this.length;
        }
    };

    function pad(num, length) {
        var ret = num + "";

        while (ret.length < length) {
            ret = "0" + ret;
        }

        return ret;
    }

    function serialize_str(str) {
        var ret, i;

        if (/^[-_/. a-zA-Z0-9]+$/.test(str)) {
            return "(" + str + ")";
        }

        if (/^[\x00-\x7FäöüÄÖÜß]*$/.test(str)) {

            ret = "(";

            for (i = 0; i < str.length; i++) {
                var c = str[i];

                if (c === "\\" || c === "(" || c === ")") {
                    ret += "\\";
                }

                ret += c;
            }

            ret += ")";

            return ret;
        }

        ret = "(";

        ret += "\xFE\xFF";

        for (i = 0; i < str.length; i++) {
            var cu = str.charCodeAt(i);

            var c1 = String.fromCharCode(cu >> 8);

            if (c1 === "\\" || c1 === "(" || c1 === ")") {
                ret += "\\";
            }

            ret += c1;

            var c2 = String.fromCharCode(cu & 0xff);

            if (c2 === "\\" || c2 === "(" || c2 === ")") {
                ret += "\\";
            }

            ret += c2;
        }

        ret += ")";

        return ret;
    }

    function serialize(node, uncompressed) {
        var i, ret;

        if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(node)) {
            return node.num + " " + node.gen + " R";
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isNum(node)) {
            return node;
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isBool(node)) {
            return node;
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isNull(node)) {
            return "null";
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isName(node)) {
            assert(node.name);

            return "/" + node.name;
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isString(node)) {
            return serialize_str(node);
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isArray(node)) {
            ret = ["["];

            for (i = 0; i < node.length; i++) {
                ret.push(serialize(node[i], uncompressed));
            }

            ret.push("]");

            return ret.join(" ");
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isDict(node)) {
            var map = node.map;

            ret = ["<<"];

            for (var key in map) {
                ret.push("/" + key + " " + serialize(map[key], uncompressed));
            }

            ret.push(">>");

            return ret.join("\n");
        } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isStream(node)) {
            ret = "";

            delete node.dict.map.DecodeParms;

            delete node.dict.map.Filter;

            var content = node.getBytes();

            assert(content, "expecting byte content from " + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(node));

            var out;

            if (uncompressed) {
                out = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].buf2str(content);

                node.dict.map.Length = out.length;
            } else {
                out = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].buf2str(__WEBPACK_IMPORTED_MODULE_6_pako___default.a.deflate(content));

                node.dict.map.Length = out.length;

                node.dict.map.Filter = [new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name("FlateDecode")];
            }

            assert(__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isDict(node.dict));

            ret += serialize(node.dict, uncompressed);

            ret += "\nstream\n";

            ret += out;

            ret += "\nendstream\n";

            return ret;
        } else {
            throw new Error("Unknown node type " + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(node));
        }
    }

    function PDFObjects(doc) {
        this.entries = doc.get_xref_entries();

        assert(__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isArray(this.entries), "xref entries should be an Array");
    }

    PDFObjects.prototype = {
        add: function add(obj, gen) {
            var e = {
                obj: obj,

                gen: gen,

                num: this.entries.length,

                uncompressed: "added"
            };

            this.entries.push(e);

            return e;
        },

        update: function update(ref, obj) {
            assert(ref.num !== undefined);

            assert(ref.gen !== undefined);

            var e = {
                obj: obj,

                gen: ref.gen,

                num: ref.num,

                uncompressed: "added"
            };

            this.entries[e.num] = e;

            return e;
        },

        write_object: function write_object(out, e, uncompressed) {
            e.offset = out.position();

            assert(e.num !== undefined);

            var bs = serialize(e.obj, uncompressed);

            out.write_str(e.num + " " + e.gen + " obj\n");

            out.write_str(bs);

            out.write_str("\nendobj\n");
        },

        write_xref_stream: function write_xref_stream(out, prev, root_ref) {
            var map = {
                Type: new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name("XRef"),

                Size: this.entries.length + 1,

                Length: 6 * (this.entries.length + 1),

                Root: root_ref,

                W: [1, 4, 1]
            };

            if (prev !== undefined) {
                map.Prev = prev;
            }

            var bio = new BytesIO();

            var entry = this.add("__xref_stream__", 0);

            entry.offset = out.position();

            this.entries.forEach(function (e) {
                assert(e.offset !== undefined, "entry should have an offset");

                bio.write_buf(new Uint8Array([e.uncompressed ? 1 : 2, e.offset >> 24, e.offset >> 16 & 0xff, e.offset >> 8 & 0xff, e.offset & 0xff, e.gen]));
            });

            var ui8ar = bio.get_uint8array();

            var stream = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].newStream(map, ui8ar);

            entry.obj = stream;

            this.write_object(out, entry, true);
        },

        write_xref_table: function write_xref_table(out, prev, root_ref) {
            var entries = this.entries.filter(function (e) {
                return !e.is_free;
            });

            var size = 1 + entries.length;

            out.write_str("xref\n");

            out.write_str("0 " + size + "\n");

            out.write_str("0000000000 65535 f\r\n");

            entries.forEach(function (e) {
                assert(e.offset !== undefined, "entry should have an offset");

                out.write_str(pad(e.offset, 10) + " " + pad(e.gen, 5) + " n\r\n");
            });

            out.write_str("trailer\n");

            var trailer = new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Dict({
                Size: size,

                Root: root_ref
            });

            out.write_str(serialize(trailer, true));
        }
    };

    function visit_acroform_fields(doc, callback) {
        if (doc.acroForm) {
            var to_visit = doc.acroForm.map.Fields;

            if (Array.isArray(to_visit)) {
                to_visit = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_slice___default()(to_visit);

                while (to_visit.length > 0) {
                    var _n = to_visit.shift();

                    if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(_n)) {
                        var _ref = _n;

                        _n = doc.fetch(_n);

                        _n._pdfform_ref = _ref;
                    }

                    if (_n.map && _n.map.T && _n.map.Kids) {
                        callback(_n);
                    } else if (_n.map && _n.map.Kids) {
                        to_visit.push.apply(to_visit, _n.map.Kids);
                    } else if (_n.map && _n.map.Type && _n.map.Type.name == "Annot" && _n.map.T) {
                        callback(_n);
                    }
                }
            } else if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(to_visit)) {
                var ref = to_visit;

                to_visit = doc.fetch(to_visit);


                while (to_visit.length > 0) {
                    var n = to_visit.shift();

                    if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(n)) {
                        var ref = n;

                        n = doc.fetch(n);

                        n._pdfform_ref = ref;
                    }

                    if (n.map && n.map.T && n.map.Kids) {
                        callback(n);
                    } else if (n.map && n.map.Kids) {
                        to_visit.push.apply(to_visit, n.map.Kids);
                    } else if (n.map && n.map.Type && n.map.Type.name == "Annot" && n.map.T) {
                        callback(n);
                    } else if (n.map && n.map.Type && n.map.Type.name == "Annot" && n.map.AP) {}
                }
            }
        } else {

            var pages = doc.fetch(doc.root.map.Pages);

            pages.map.Kids.forEach(function (page_ref) {
                var page = doc.fetch(page_ref);

                var annots_ref = page.map.Annots;

                var annots = doc.fetch(annots_ref);

                annots.forEach(function (annot_ref) {
                    var n = doc.fetch(annot_ref);

                    n._pdfform_ref = annot_ref;

                    n._inpage_annot = true;

                    if (n.map && n.map.Type && n.map.Type.name == "Annot" && n.map.T) {
                        callback(n);
                    }
                });
            });
        }
    }

    function pdf_decode_str(str) {
        if (!str.startsWith("\xFE\xFF")) {
            return str;
        }

        var res = "";

        for (var i = 2; i < str.length; i += 2) {
            res += String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1));
        }

        return res;
    }

    function acroform_match_spec(n, fields) {
        var t = pdf_decode_str(n.map.T);

        if (t in fields) {
            return fields[t][0];
        } else {
            var m = /^(.*)\[([0-9]+)\]$/.exec(t);

            if (m && m[1] in fields) {
                return fields[m[1]][m[2]];
            }
        }

        return undefined;
    }

    function modify_xfa(doc, objects, out, index, callback) {
        if (!doc.acroForm) {
            return;
        }

        var xfa = doc.acroForm.map.XFA;

        if (!xfa) {
            return;
        }

        var section_idx = xfa.indexOf(index);

        assert(section_idx >= 0);

        var section_ref = xfa[section_idx + 1];

        var section_node = doc.fetch(section_ref);

        assert(__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isStream(section_node), "XFA section node should be a stream");

        var bs = section_node.getBytes();

        assert(bs);

        var prev_str = new TextDecoder("utf-8").decode(bs);

        var str = callback(prev_str);

        var out_bs = new TextEncoder("utf-8").encode(str);

        var out_node = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].newStream(section_node.dict.map, out_bs);

        assert(__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isStream(out_node));

        var e = objects.update(section_ref, out_node);

        objects.write_object(out, e);
    }

    function robotsInDisguise(buf, fields) {
        var doc = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].parse(new Uint8Array(buf));

        var objects = new PDFObjects(doc);

        var root_id = doc.get_root_id();

        var root_ref = new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Ref(root_id, 0);

        var out = new BytesIO();

        out.write_buf(new Uint8Array(buf));

        visit_acroform_fields(doc, function (n) {

            var spec = acroform_match_spec(n, fields);

            if (spec === undefined) {
                return;
            }

            var ft_name = n.map.FT.name;

            if (ft_name == "Tx") {
                n.map.V = "" + spec;
            } else if (ft_name == "Btn") {
                if (n.map.Kids) {
                    var matching = null;
                    var specs = [];
                    n.map.Kids.forEach(function (element) {
                        if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(element)) {

                            var ref = element;

                            var m = doc.fetch(element);

                            var ap = m.map.AP;
                            var nnn = null;

                            if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(ap)) {
                                ap = doc.fetch(ap);
                                nnn = doc.fetch(ap.map.N);
                            } else {
                                nnn = ap.map.N;
                            }

                            specs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(nnn.map));

                            m._pdfform_ref = ref;

                            if (spec in nnn.map) {
                                m.map.AS = m.map.V = m.map.DV = m.map.DN = new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name(spec);
                                matching = ref;
                            } else {
                                m.map.AS = m.map.V = m.map.DV = m.map.DN = new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name("Off");
                            }

                            var e = objects.update(ref, m);

                            objects.write_object(out, e);
                        }
                    });

                    if (!matching) {
                        console.log(n.map.T + ": Could not find " + spec + " in " + specs.join(', '));
                    }

                    n.map.V = new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name(spec);
                } else {
                    n.map.AS = n.map.V = n.map.DV = spec ? new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name("Yes") : new __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].Name("Off");
                }
            } else if (ft_name == "Ch") {
                n.map.V = "" + spec;
            } else if (ft_name == "Sig") {
                return;
            } else {
                throw new Error("Unsupported input type " + n.map.FT.name);
            }

            var ref = n._pdfform_ref;

            var e = objects.update(ref, n);

            objects.write_object(out, e);
        });

        var acroform_ref = doc.get_acroform_ref();

        if (acroform_ref) {

            doc.acroForm.map.NeedAppearances = true;

            if (__WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].isRef(acroform_ref)) {

                var e = objects.update(acroform_ref, doc.acroForm);

                objects.write_object(out, e);
            } else {

                doc.root.map.AcroForm = doc.acroForm;

                var root = objects.update(root_ref, doc.root);

                objects.write_object(out, root);
            }
        }

        modify_xfa(doc, objects, out, "datasets", function (str) {

            str = str.replace(/\n(\/?>)/g, "$1\n");

            var ds_doc = new __WEBPACK_IMPORTED_MODULE_3_xmldom__["DOMParser"]().parseFromString(str, "application/xml");

            for (var f in fields) {
                var els = ds_doc.getElementsByTagName(f);

                for (var i = 0; i < els.length; i++) {
                    var val = fields[f][i];

                    if (val === undefined) {
                        continue;
                    }

                    var el = els[i];

                    while (el.firstChild) {
                        el.removeChild(el.firstChild);
                    }

                    if (typeof val == "boolean") {
                        val = val ? 1 : 0;
                    }

                    el.appendChild(ds_doc.createTextNode(val));
                }
            }

            str = new XMLSerializer().serializeToString(ds_doc);

            return str;
        });

        var startxref = out.position();

        if (doc.xref_type === "table") {
            objects.write_xref_table(out, doc.startXRef, root_ref);
        } else {
            objects.write_xref_stream(out, doc.startXRef, root_ref);
        }

        out.write_str("\nstartxref\n");

        out.write_str(startxref + "\n");

        out.write_str("%%EOF");

        return out.get_uint8array();
    }

    function list_fields(data) {
        var doc = __WEBPACK_IMPORTED_MODULE_5__minipdf_js__["a" /* default */].parse(new Uint8Array(data));

        var res = {};

        visit_acroform_fields(doc, function (n) {
            var raw_name = pdf_decode_str(n.map.T);

            var name = raw_name;

            var index = 0;

            var m = /^(.+?)\[([0-9]+)\]$/.exec(raw_name);

            if (m) {
                name = m[1];

                index = parseInt(m[2], 10);
            }

            var spec;

            var ft_name = n.map.FT.name;

            if (ft_name === "Tx") {
                spec = { type: "string" };
            } else if (ft_name === "Btn") {
                spec = { type: "boolean" };
            } else if (ft_name === "Ch") {
                spec = {
                    type: "select",

                    options: n.map.Opt.slice()
                };
            } else if (ft_name === "Sig") {
                return;
            } else {
                throw new Error("Unsupported input type" + ft_name);
            }

            if (!res[name]) {
                res[name] = [];
            }

            res[name][index] = spec;
        });

        return res;
    }

    return {
        robotsInDisguise: robotsInDisguise,

        list_fields: list_fields,

        _serialize_str: serialize_str,

        _decode_str: pdf_decode_str
    };
}

pdfform.robotsInDisguise = function (buf, fields) {
    return pdfform().transform(buf, fields);
};

/* unused harmony default export */ var _unused_webpack_default_export = (pdfform);

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tfs-logo-optimized.158b366.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_datetimepicker__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_wc_validated_mixin_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_wc_validated_mixin_js__["a" /* default */]],
    components: {
        datePicker: __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_datetimepicker___default.a
    },
    props: {
        label: { type: String, default: null },
        value: null,
        value0: null,
        disabled: { type: Boolean, default: false },
        neverDirty: { type: Boolean, default: false }
    },
    computed: {
        isDirty: function isDirty() {
            return this.neverDirty === false && this.value0 !== this.date;
        }
    },
    data: function data() {
        return {
            date: new Date(),
            config: {
                format: 'MM/DD/YYYY',
                useCurrent: false
            }
        };
    },

    methods: {
        update: function update(e) {
            this.junk++;
            this.$emit('input', e.target.value);
        }
    },
    created: function created() {
        this.date = this.value;
    }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_wc_validated_mixin_js__ = __webpack_require__(105);




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_wc_validated_mixin_js__["a" /* default */]],
    props: {
        type: { type: String, default: 'text' },
        label: { type: String, default: null },
        value: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        value0: { type: String, default: '' },
        neverDirty: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        customErrorMsg: { type: String, default: null }
    },
    computed: {
        isDirty: function isDirty() {
            return this.neverDirty === false && this.value0 !== this.value;
        }
    },
    methods: {
        update: function update(e) {
            this.touch(e);
            this.$emit('input', e.target.value);
        }
    }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_wc_validated_mixin_js__ = __webpack_require__(105);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_wc_validated_mixin_js__["a" /* default */]],
    props: {
        rows: { type: String, default: '4' },
        label: { type: String, default: null },
        value: { type: String, default: '' },
        value0: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        isAwesome: { type: Boolean, default: false }
    },
    computed: {
        isDirty: function isDirty() {
            return this.value0 !== this.value;
        }
    },
    methods: {
        update: function update(e) {
            this.$emit('input', e.target.value);
        }
    }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        inspectionStatusBadge: __webpack_require__(159)
    },
    props: {
        inspections: { type: Array, default: [] },
        inspectionsMeta: { type: Object, default: function _default() {
                return { total: 0, page: 0 };
            } },
        columns: { type: Array, default: [] }
    },
    computed: {
        showInspector: function showInspector() {
            return this.columns.indexOf('inspector') >= 0;
        },
        showDelete: function showDelete() {
            return this.columns.indexOf('delete') >= 0;
        }
    },
    methods: {
        onRowClick: function onRowClick(target, inspection) {
            if (target.type != "button" && (!target.parentNode || target.parentNode.type != "button")) {
                this.$router.push('/inspections/' + inspection.id);
            }
        },
        onDeleteInspectionClick: function onDeleteInspectionClick(inspectionId) {
            this.$emit("deleteInspection", [inspectionId]);
        }
    }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        inspection: {
            status: null
        }
    }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            inspector: this.$schema.map('inspector'),
            regions: [],
            working: false
        };
    },

    methods: {
        create: function create() {
            var _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$toasted.error('Please complete all required fields.');
                return;
            }

            this.working = true;

            this.axios.post('inspectors', this.inspector).then(function (response) {
                _this.working = false;

                _.each(_this.inspector, function (item) {
                    item = '';
                });

                _this.$emit('created', response.data);

                if (response.data.meta && response.data.meta.error) {
                    _this.$swal({
                        title: 'Error encountered!',
                        text: response.data.meta.error,
                        type: "error",
                        confirmButtonText: 'OK'
                    });
                } else {
                    _this.$toasted.success('Forester created!');
                }
                jQuery('#modal-create-inspector').modal('toggle');
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.axios.get('regions').then(function (response) {
            _this2.regions = response.data.data;
        });
    },

    validations: {
        inspector: {
            inspector_license: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
            user: {
                email: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"] },
                contact: {
                    first_name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
                    last_name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
                    address: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
                    locality: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
                    region_id: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
                    postal_code: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39), __webpack_require__(13)))

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapbox_gl__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapbox_mapbox_gl_geocoder__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapbox_mapbox_gl_geocoder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mapbox_mapbox_gl_geocoder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_missing_parcel_marker_png__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_missing_parcel_marker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_missing_parcel_marker_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_woodland_marker_png__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_woodland_marker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_woodland_marker_png__);







var MapboxDraw = __webpack_require__(383);
var turfBBox = __webpack_require__(167).default;
var turfArea = __webpack_require__(366).default;




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    props: {
        'access-token': {
            type: String,
            required: false,
            default: 'pk.eyJ1Ijoid29vZHNjYW1wLWNvbGlubiIsImEiOiJjamxnd3VycDgxYzZyM3dyMG91ZXFkNXN0In0.dQpj9Uxzn_Jq_AXwUHloMw'
        },

        'map-style': {
            type: [String, Object],
            default: 'mapbox://styles/mapbox/satellite-streets-v10'
        },

        'attribution-control': {
            type: Boolean,
            default: true
        },

        interactive: {
            type: Boolean,
            default: true
        },

        useGeocoder: {
            type: Boolean,
            default: false
        },

        transitionMode: {
            type: String,
            required: false,
            default: 'jump',
            validator: function validator(value) {
                return ['jump', 'ease', 'fly'].indexOf(value) !== -1;
            }
        },

        lng: {
            type: [Number, String],
            required: false,
            default: -84.547936
        },

        lat: {
            type: [Number, String],
            required: false,
            default: 32.234294
        },

        zoom: {
            type: [Number, String],
            default: 6
        },

        pitch: {
            type: [Number, String],
            default: 0
        },

        bearing: {
            type: [Number, String],
            default: 0
        },

        parcelStrokeColour: {
            type: String,
            default: '#a3ca55'
        },

        parcelHighlightStrokeColour: {
            type: String,
            default: '#f4c842'
        },

        allowDrawing: {
            default: true,
            type: Boolean
        },
        drawingGeoJSON: {
            default: null,
            type: Object
        },

        parcels: {
            default: null,
            type: Array
        },
        missingParcels: {
            type: Array
        },
        centroids: {
            type: Array
        }
    },
    data: function data() {
        return {
            map: null,
            drawObject: null,
            geocoder: null,

            overFeatureId: '',
            popup: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.accessToken) {
            __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.accessToken = this.accessToken;
        } else {
            console.warn('NOTE -> No access token has been provided. If using Mapbox hosted tiles then this omission may break your map.');
        }
        this.map = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.Map({
            container: this.$refs.mapboxMapDiv,
            style: this.mapStyle,
            interactive: this.interactive,
            center: [this.lng, this.lat],
            zoom: this.zoom,
            bearing: this.bearing,
            pitch: this.pitch,
            attributionControl: this.attributionControl,
            preserveDrawingBuffer: true
        });

        this.map.on('load', function () {
            _this.setMap(_this.map);
        });
        this.map.on('remove', function () {
            _this.unsetMap();
        });
    },

    computed: {
        mapScene: function mapScene() {
            return {
                center: [this.lng, this.lat],
                zoom: this.zoom,
                bearing: this.bearing,
                pitch: this.pitch
            };
        }
    },
    watch: {
        mapStyle: {
            deep: true,
            handler: function handler(val) {
                if (val && this.map) {
                    this.map.setStyle(val);
                } else {
                    console.error('NOTE -> Unable to update map style to ' + val + '.');
                }
            }
        },
        mapScene: function mapScene(val) {
            if (val) {
                if (!this.map) {
                    console.error('NOTE -> Map object not set');
                    return;
                }
                if (val.pitch < 0 || val.pitch > 60) {
                    console.error('NOTE -> Unable to update pitch to ' + val.pitch + '. Exceeds permitted range.');
                    return;
                }
                if (val.bearing < 0 || val.bearing > 360) {
                    console.error('NOTE -> Unable to update bearing to ' + val.bearing + '. Exceeds permitted range.');
                    return;
                }
                if (this.transitionMode === 'jump') {
                    this.map.jumpTo(val);
                } else if (this.transitionMode === 'ease') {
                    this.map.easeTo(val);
                } else if (this.transitionMode === 'fly') {
                    this.map.flyTo(val);
                }
            }
        },


        missingParcels: function missingParcels() {
            this.renderMissingParcels();
        },

        parcels: function parcels() {
            this.renderParcels();
        },

        drawingGeoJSON: {
            handler: function handler() {
                if (this.drawObject) {
                    var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.drawObject.getAll());
                    var b = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.drawingGeoJSON);

                    if (a !== b) {
                        this.drawObject.deleteAll();
                        this.drawObject.add(this.drawingGeoJSON);
                    }
                }
            },

            deep: true
        }
    },

    methods: {
        setMap: function setMap(map) {
            var _this2 = this;

            this.map = map;

            this.map.setMaxZoom(16.9);

            {
                this.geocoder = new __WEBPACK_IMPORTED_MODULE_3__mapbox_mapbox_gl_geocoder___default.a({
                    accessToken: __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.accessToken,
                    country: 'us',
                    bbox: [-89.121094, 29.458731, -82.792969, 35.245619]
                });

                this.geocoder.on('results', function (e) {
                    if (e.features && e.features.length == 0) {
                        _this2.$toasted.error('Cound not geolocate address.');
                    }
                });

                this.geocoder.on('error', function (e) {
                    _this2.$toasted.error('Unknown error');
                });

                this.map.addControl(this.geocoder);
            }

            if (this.interactive) {
                var nav = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.NavigationControl();
                map.addControl(nav, 'top-right');
            }

            {
                map.on('mouseenter', 'certpilot-highlighted', this.onMouseEnter_highlighted);
                map.on('mouseenter', 'missing-parcels', this.onMouseEnter_missing);
                map.on('mouseenter', 'woodland-centroids', this.onMouseEnter_centroids);

                map.on('mouseleave', 'certpilot-highlighted', this.onMouseLeave_highlighted);
                map.on('mouseleave', 'missing-parcels', this.onMouseLeave_missing);
                map.on('mouseleave', 'woodland-centroids', this.onMouseLeave_centroids);

                map.on('click', 'certpilot-highlighted', this.onMapClick_highlighted);
                map.on('click', 'missing-parcels', this.onMapClick_missing);
                map.on('click', 'woodland-centroids', this.onMapClick_centroids);
            }

            {
                var tileserver = 'https://tiles.woodscamp.com:8089/certpilot/{z}/{x}/{y}.pbf';

                map.addSource('parcels', {
                    type: 'vector',
                    tiles: [tileserver]
                });

                map.addLayer({
                    id: 'certpilot',
                    type: 'fill',
                    source: 'parcels',
                    'source-layer': 'certpilot',
                    paint: {
                        'fill-color': this.parcelStrokeColour,
                        'fill-opacity': 0
                    },
                    'minzoom': 10,
                    'maxzoom': 17
                });
                map.addLayer({
                    'id': 'certpilot-lines',
                    'type': 'line',
                    source: 'parcels',
                    'source-layer': 'certpilot',
                    'paint': {
                        'line-color': this.parcelStrokeColour,
                        'line-width': 1,
                        'line-opacity': 0.6
                    },
                    'minzoom': 10,
                    'maxzoom': 17
                });

                map.addLayer({
                    id: 'certpilot-almost-highlighted',
                    type: 'fill',
                    source: 'parcels',
                    'source-layer': 'certpilot',
                    paint: {
                        'fill-outline-color': this.parcelStrokeColour,
                        'fill-color': this.parcelStrokeColour,
                        'fill-opacity': 0.25
                    },
                    'minzoom': 10,
                    'maxzoom': 17,
                    filter: ['in', 'id', '']
                });

                map.addLayer({
                    id: 'certpilot-highlighted',
                    type: 'fill',
                    source: 'parcels',
                    'source-layer': 'certpilot',
                    paint: {
                        'fill-outline-color': this.parcelHighlightStrokeColour,
                        'fill-color': this.parcelHighlightStrokeColour,
                        'fill-opacity': 0.15
                    },
                    'minzoom': 10,
                    'maxzoom': 17,
                    filter: ['in', 'id', '']
                });
                map.addLayer({
                    'id': 'certpilot-highlighted-lines',
                    'type': 'line',
                    source: 'parcels',
                    'source-layer': 'certpilot',
                    'paint': {
                        'line-color': this.parcelHighlightStrokeColour,
                        'line-width': 3,
                        'line-opacity': 1
                    },
                    'minzoom': 10,
                    'maxzoom': 17,
                    filter: ['in', 'id', '']
                });

                map.addSource('missing-parcels', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: []
                    }
                });
                map.loadImage(__WEBPACK_IMPORTED_MODULE_4__assets_img_missing_parcel_marker_png___default.a, function (error, image) {
                    if (error) throw error;
                    map.addImage('missing-parcel', image);

                    map.addLayer({
                        id: 'missing-parcels',
                        type: 'symbol',
                        source: 'missing-parcels',
                        layout: {
                            'icon-image': 'missing-parcel',
                            'icon-size': 0.4
                        }
                    });
                });

                map.addSource('woodland-centroids', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: []
                    }
                });
                map.loadImage(__WEBPACK_IMPORTED_MODULE_5__assets_img_woodland_marker_png___default.a, function (error, image) {
                    if (error) throw error;
                    map.addImage('woodland-pin', image);

                    map.addLayer({
                        id: 'woodland-centroids',
                        type: 'symbol',
                        source: 'woodland-centroids',
                        layout: {
                            'icon-image': 'woodland-pin',
                            'icon-size': 0.4
                        }
                    });
                });
            }

            {
                this.drawObject = new MapboxDraw({
                    userProperties: true,
                    touchEnabled: this.allowDrawing,
                    controls: {
                        point: false,
                        line_string: false,
                        polygon: this.allowDrawing,
                        trash: this.allowDrawing,
                        combine_features: false,
                        uncombine_features: false
                    },

                    styles: [{
                        id: 'gl-draw-polygon-fill-inactive',
                        type: 'fill',
                        filter: ['all', ['==', '$type', 'Polygon']],
                        paint: {
                            'fill-color': ['get', 'user_colour'],
                            'fill-outline-color': '#3bb2d0',
                            'fill-opacity': ['case', ['==', ['get', 'user_colour'], ''], 0, 0.25]
                        }
                    }, {
                        id: 'gl-draw-polygon-fill-active',
                        type: 'fill',
                        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
                        paint: {
                            'fill-color': '#fbb03b',
                            'fill-outline-color': '#fbb03b',
                            'fill-opacity': 0.1
                        }
                    }, {
                        id: 'gl-draw-polygon-midpoint',
                        type: 'circle',
                        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
                        paint: {
                            'circle-radius': 3,
                            'circle-color': '#fbb03b'
                        }
                    }, {
                        id: 'gl-draw-polygon-stroke-inactive',
                        type: 'line',
                        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#3bb2d0',
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-polygon-stroke-active',
                        type: 'line',
                        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#fbb03b',
                            'line-dasharray': [0.2, 2],
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-line-inactive',
                        type: 'line',
                        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#3bb2d0',
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-line-active',
                        type: 'line',
                        filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#fbb03b',
                            'line-dasharray': [0.2, 2],
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
                        type: 'circle',
                        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
                        paint: {
                            'circle-radius': 5,
                            'circle-color': '#fff'
                        }
                    }, {
                        id: 'gl-draw-polygon-and-line-vertex-inactive',
                        type: 'circle',
                        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
                        paint: {
                            'circle-radius': 3,
                            'circle-color': '#fbb03b'
                        }
                    }, {
                        id: 'gl-draw-point-point-stroke-inactive',
                        type: 'circle',
                        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
                        paint: {
                            'circle-radius': 5,
                            'circle-opacity': 1,
                            'circle-color': '#fff'
                        }
                    }, {
                        id: 'gl-draw-point-inactive',
                        type: 'circle',
                        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
                        paint: {
                            'circle-radius': 3,
                            'circle-color': '#3bb2d0'
                        }
                    }, {
                        id: 'gl-draw-point-stroke-active',
                        type: 'circle',
                        filter: ['all', ['==', '$type', 'Point'], ['==', 'active', 'true'], ['!=', 'meta', 'midpoint']],
                        paint: {
                            'circle-radius': 7,
                            'circle-color': '#fff'
                        }
                    }, {
                        id: 'gl-draw-point-active',
                        type: 'circle',
                        filter: ['all', ['==', '$type', 'Point'], ['!=', 'meta', 'midpoint'], ['==', 'active', 'true']],
                        paint: {
                            'circle-radius': 5,
                            'circle-color': '#fbb03b'
                        }
                    }, {
                        id: 'gl-draw-polygon-fill-static',
                        type: 'fill',
                        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
                        paint: {
                            'fill-color': '#404040',
                            'fill-outline-color': '#404040',
                            'fill-opacity': 0.1
                        }
                    }, {
                        id: 'gl-draw-polygon-stroke-static',
                        type: 'line',
                        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#404040',
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-line-static',
                        type: 'line',
                        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#404040',
                            'line-width': 2
                        }
                    }, {
                        id: 'gl-draw-point-static',
                        type: 'circle',
                        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
                        paint: {
                            'circle-radius': 5,
                            'circle-color': '#404040'
                        }
                    }]
                });

                if (this.allowDrawing || this.drawingGeoJSON) {
                    map.addControl(this.drawObject, 'top-left');

                    map.on('draw.create', this.emitDrawing);
                    map.on('draw.update', this.emitDrawing);
                    map.on('draw.delete', this.emitDrawing);
                }

                if (this.drawingGeoJSON) {
                    this.drawObject.set(this.drawingGeoJSON);
                }
            }

            map.on('click', this.onMapClick);
            map.on('mousemove', this.onMouseMove);

            this.popup = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.Popup({
                closeButton: false,
                closeOnClick: false
            });

            this.renderParcels();
            this.renderMissingParcels();
            this.renderCentroids();
            this.fitBounds();
        },
        emitDrawing: function emitDrawing() {
            if (this.drawObject) {
                this.$emit('drawing', this.drawObject.getAll());
            }
        },
        unsetMap: function unsetMap() {
            this.map.off('draw.create', this.emitDrawing);
            this.map.off('draw.update', this.emitDrawing);
            this.map.off('draw.delete', this.emitDrawing);
            this.map.off('click', this.onMapClick);
            this.map.off('mousemove', this.onMouseMove);

            this.map.off('mouseenter', 'certpilot-highlighted', this.onMouseEnter_highlighted);
            this.map.off('mouseenter', 'missing-parcels', this.onMouseEnter_missing);
            this.map.off('mouseenter', 'woodland-centroids', this.onMouseEnter_centroids);

            this.map.off('mouseleave', 'certpilot-highlighted', this.onMouseLeave_highlighted);
            this.map.off('mouseleave', 'missing-parcels', this.onMouseLeave_missing);
            this.map.off('mouseleave', 'woodland-centroids', this.onMouseLeave_centroids);

            this.map.off('click', 'certpilot-highlighted', this.onMapClick_highlighted);
            this.map.off('click', 'missing-parcels', this.onMapClick_missing);
            this.map.off('click', 'woodland-centroids', this.onMapClick_centroids);

            this.map = null;
        },
        onMapClick: function onMapClick(e) {
            try {
                if (this.map && this.drawObject && this.drawObject.getFeatureIdsAt(e.point).length || this.drawObject.getMode() != 'simple_select') {
                    return;
                }
                this.$emit('mapclick', e);
            } catch (e) {}
        },
        onMouseMove: function onMouseMove(e) {
            if (!this.interactive) return;


            if (this.drawObject) {
                var featureIds = this.drawObject.getFeatureIdsAt(e.point);

                if (featureIds.length) {
                    if (featureIds[0] != this.overFeatureId) {
                        if (this.overFeatureId != '') {
                            this.popup.remove();
                        }

                        var drawFeature = this.drawObject.get(featureIds[0]);

                        if (drawFeature) {
                            var name = drawFeature.properties.name ? drawFeature.properties.name : 'unnamed';
                            var description = drawFeature.properties.notes ? drawFeature.properties.notes : '';
                            var area = (turfArea(drawFeature) / 4046.86).toFixed(2);

                            if (name || description || area) {
                                this.popup.setLngLat(e.lngLat).setHTML(name + ', ' + area + ' acres<p>' + description).addTo(this.map);
                            }
                        }

                        this.overFeatureId = featureIds[0];
                    }
                } else {
                    this.overFeatureId = '';
                    this.popup.remove();
                }
            }

            if (!this.overFeatureId) {
                var features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['certpilot']
                });

                var filter = features.reduce(function (memo, feature) {
                    memo.push(feature.properties.id);
                    return memo;
                }, ['in', 'id']);

                this.map.setFilter('certpilot-almost-highlighted', filter);
            }
        },
        onMouseEnter_highlighted: function onMouseEnter_highlighted(e) {
            this.$emit('enter', e.features[0].properties);
        },
        onMouseEnter_missing: function onMouseEnter_missing(e) {
            this.$emit('enter', e.features[0].properties);
        },
        onMouseEnter_centroids: function onMouseEnter_centroids(e) {
            this.$emit('enter', e.features[0].properties);
        },
        onMouseLeave_highlighted: function onMouseLeave_highlighted(e) {
            this.$emit('leave');
        },
        onMouseLeave_missing: function onMouseLeave_missing(e) {
            this.$emit('leave');
        },
        onMouseLeave_centroids: function onMouseLeave_centroids(e) {
            this.$emit('leave');
        },
        onMapClick_highlighted: function onMapClick_highlighted(e) {
            e.preventDefault();
            this.$emit('click', this.parcels.find(function (p) {
                return p.id === e.features[0].properties.id;
            }));
        },
        onMapClick_missing: function onMapClick_missing(e) {
            e.preventDefault();
            this.$emit('click', this.missingParcels.find(function (p) {
                return p.id === e.features[0].properties.id;
            }));
        },
        onMapClick_centroids: function onMapClick_centroids(e) {
            e.preventDefault();
            this.$emit('click', this.centroids.find(function (p) {
                return p.id === e.features[0].properties.id;
            }));
        },
        getMapInstance: function getMapInstance() {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                resolve(_this3.map);
            });
        },
        resetMap: function resetMap() {
            var _this4 = this;

            return this.getMapInstance(function (map) {
                map.setCenter(_this4.center);
                map.setZoom(_this4.zoom);
            });
        },
        renderParcels: function renderParcels() {
            if (this.parcels && this.map) {
                var filter = this.parcels.reduce(function (memo, parcel) {
                    memo.push(parcel.id);
                    return memo;
                }, ['in', 'id']);

                this.map.setFilter('certpilot-highlighted', filter);
                this.map.setFilter('certpilot-highlighted-lines', filter);
            }
        },
        renderMissingParcels: function renderMissingParcels() {
            var features = [];

            if (this.map && this.missingParcels) {
                this.missingParcels.forEach(function (marker) {
                    features.push({
                        type: 'Feature',
                        properties: marker,
                        geometry: {
                            type: 'Point',
                            coordinates: [marker.position.lng, marker.position.lat]
                        }
                    });
                });

                this.map.getSource('missing-parcels').setData({
                    type: 'FeatureCollection',
                    features: features
                });
            }
        },
        renderCentroids: function renderCentroids() {
            var centroids = [];

            if (this.map && this.centroids) {
                this.centroids.forEach(function (marker) {
                    centroids.push({
                        type: 'Feature',
                        properties: marker,
                        geometry: {
                            type: 'Point',
                            coordinates: [marker.position.lng, marker.position.lat]
                        }
                    });
                });

                this.map.getSource('woodland-centroids').setData({
                    type: 'FeatureCollection',
                    features: centroids
                });
            }
        },
        fitBounds: function fitBounds() {
            if (this.map && (this.parcels && this.parcels.length || this.missingParcels && this.missingParcels.length)) {
                var bounds = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.LngLatBounds();

                if (this.parcels) {
                    _.each(this.parcels, function (parcel) {
                        var bbox = turfBBox(JSON.parse(parcel.geom));

                        bounds.extend(new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.LngLat(bbox[0], bbox[1]));
                        bounds.extend(new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.LngLat(bbox[2], bbox[3]));
                    });
                }

                if (this.missingParcels) {
                    _.each(this.missingParcels, function (point) {
                        bounds.extend(point.position);
                    });
                }

                this.map.fitBounds(bounds, { padding: 120, duration: 0 });
            } else {}
        },
        highlightMapFeatures: function highlightMapFeatures() {
            var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        },
        unhighlightMapFeatures: function unhighlightMapFeatures() {
            var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        },
        centerOnAddress: function centerOnAddress(address) {
            var self = this;

            this.getMapInstance().then(function (map) {
                var res = address.match(/([+-]?([0-9]+([.][0-9]*)?|[.][0-9]+))\s*,\s*([+-]?([0-9]+([.][0-9]*)?|[.][0-9]+))/);

                if (res) {
                    console.log(res);
                    map.setCenter(new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.LngLat(res[4], res[1]));
                    map.setZoom(12);
                } else {
                    if (self.geocoder && self.map) {
                        self.geocoder.query(address);
                    }
                }
            }).catch(function (e) {
                return console.log(e);
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    props: {
        count: { type: Number, default: 0 },
        total: { type: Number, default: 0 },
        page: { type: Number, default: 1 }
    },
    computed: {
        totalPageCount: function totalPageCount() {
            return Math.max(1, Math.ceil(this.total / this.count));
        },
        pages: function pages() {
            var maxPagesSeen = this.totalPageCount > 10 ? 10 : this.totalPageCount;
            var maxPagesSeenMultiple = Math.ceil(this.totalPageCount / maxPagesSeen);

            var pageStart_1base = 1;
            if (this.page > maxPagesSeen / 2) {
                pageStart_1base = this.page - Math.floor(maxPagesSeen / 2);
            }
            if (this.page > this.totalPageCount - maxPagesSeen / 2) {
                pageStart_1base = this.totalPageCount - maxPagesSeen + 1;
            }

            return Array(maxPagesSeen).fill().map(function (e, i) {
                return i + pageStart_1base;
            });
        }
    },
    methods: {
        go: function go(page_1base) {
            if (page_1base > 0 && page_1base <= this.totalPageCount) {
                this.$emit("go", page_1base);
            }
        }
    }
});

/***/ }),

/***/ 445:
/***/ (function(module, exports) {



/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_pdf_pdfform_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_role_mixins_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_inspections_api_mixin_js__ = __webpack_require__(173);







/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_role_mixins_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_inspections_api_mixin_js__["a" /* default */]],
    methods: {
        isActiveRoute: function isActiveRoute(name) {
            return this.$route.name.startsWith(name);
        },
        logout: function logout() {
            this.$store.dispatch('auth/logout');
            this.$router.push('login');
        },
        newInspection: function newInspection() {
            var _this = this;

            this.createInspection().then(function (response) {
                _this.$router.push('/inspections/' + response.data.id);
            });
        }
    }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {}
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'inspectors-single',
    components: {
        layout: __webpack_require__(57),
        inspectionStatusBadge: __webpack_require__(159)
    },
    data: function data() {
        return {
            regions: [],
            working: true,
            inspector: this.$schema.map('inspector'),

            password: null,
            repeatPassword: null
        };
    },

    methods: {
        updateTab: function updateTab(tab) {
            jQuery('#' + tab + '-btn').tab('show');
        },
        updateInspector: function updateInspector() {
            var _this = this;

            this.working = true;

            if (this.password && !this.$v.$invalid || !this.password) {

                if (this.password) {
                    this.inspector.user.password = this.password;
                }

                this.axios.put('inspectors/' + this.$route.params.id, this.inspector).then(function (response) {
                    _this.$toasted.success('Forester details updated!');
                }).then(function () {
                    _this.getInspector();
                    _this.working = false;
                });
            } else {
                this.$toasted.error('Password form has errors that need to be corrected.');
                this.updateTab('password');
                this.working = false;
            }
        },
        getInspector: function getInspector() {
            var self = this;
            this.working = true;

            this.axios.get('inspectors/' + this.$route.params.id + '?include=user,inspections.contact,inspections.region,inspections.status').then(function (response) {
                self.working = false;
                self.inspector = response.data;
                console.l;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.axios.get('regions').then(function (response) {
            _this2.regions = response.data.data;
        });

        this.getInspector();
    },

    validations: {
        password: {
            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(8)
        },
        repeatPassword: {
            sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('password')
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'inspectors',
    data: function data() {
        return {
            inspectors: null,
            search: '',
            working: true
        };
    },

    components: {
        layout: __webpack_require__(57),
        inspectorCreateModal: __webpack_require__(798)
    },
    methods: {
        getInspectors: function getInspectors() {
            var self = this;
            var searchString = '';
            if (self.search) {
                var searchable = { 'id': '=', 'first_name': '~', 'last_name': '~', 'email': '~' };
                _.each(searchable, function (symbol, field) {
                    searchString += (searchString === '' ? '?q=' : '|^') + field + symbol + (symbol === '~' ? '*' : '') + self.search + (symbol === '~' ? '*' : '');
                });
            }

            this.working = true;

            self.axios.get('inspectors?include=contact').then(function (response) {
                self.inspectors = response.data.data;
                self.working = false;
            });
        },
        onRowClick: function onRowClick(target, inspector) {
            if (target.type != "button" && (!target.parentNode || target.parentNode.type != "button")) {
                this.$router.push({ path: '/foresters/' + inspector.id });
            }
        },
        onInspectorDisable: function onInspectorDisable(inspector) {
            var _this = this;

            this.$swal({
                title: 'Disable ' + inspector.user.contact.first_name + ' ' + inspector.user.contact.last_name + '?',
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Disable',
                cancelButtonText: 'Cancel'
            }).then(function (result) {
                if (result.value) {
                    return _this.axios.post('inspectors/' + inspector.id + '/disable').then(function (result) {
                        _this.getInspectors();
                        _this.$swal('Success!', 'The inspector privileges have been disabled.', 'success');
                    });
                }
            });
        },
        onInspectorEnable: function onInspectorEnable(inspector) {
            var _this2 = this;

            this.$swal({
                title: 'Enable ' + inspector.user.contact.first_name + ' ' + inspector.user.contact.last_name + '?',
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Enable',
                cancelButtonText: 'Cancel'
            }).then(function (result) {
                if (result.value) {
                    return _this2.axios.post('inspectors/' + inspector.id + '/enable').then(function (result) {
                        _this2.getInspectors();
                        _this2.$swal('Success!', 'The inspector privileges have been enabled.', 'success');
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getInspectors();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_role_mixins_js__ = __webpack_require__(67);




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_role_mixins_js__["a" /* default */]],
    name: 'help',
    components: {
        layout: __webpack_require__(57),
        wcInput: __webpack_require__(104),
        wcTextarea: __webpack_require__(365)
    },
    data: function data() {
        return {
            user: this.$schema.map('user'),
            message: '',
            working: false,
            result: null,
            contactPhone: '1-800-492-6216'
        };
    },


    methods: {
        getUser: function getUser() {
            var self = this;
            this.working = true;

            this.axios.get('users/me' + '?include=contact').then(function (response) {
                self.working = false;
                self.user = response.data;
            });
        },
        sendMessage: function sendMessage() {
            var _this = this;

            this.working = true;

            this.axios.post('help', { user: this.user, message: this.message }).then(function (response) {
                _this.working = false;

                _this.result = true;
            }).catch(function (e) {
                _this.working = false;
                _this.result = false;
            });;
        }
    },

    created: function created() {
        this.getUser();
    },


    validations: {}
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_role_mixins_js__ = __webpack_require__(67);




Date.prototype.formatMMDDYYYY = function () {
    return this.getMonth() + 1 + "/" + this.getDate() + "/" + this.getFullYear();
};

var today = new Date();
var twoWeeksAgo = new Date();twoWeeksAgo.setDate(today.getDate() - 7);

/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_role_mixins_js__["a" /* default */]],
    name: 'home',
    components: {
        layout: __webpack_require__(57),
        inspectionList: __webpack_require__(357),
        wcDate: __webpack_require__(364)
    },
    data: function data() {
        return {
            stats: [],
            inspections: [],
            chart: null,
            recentLength: 10,
            user: this.$schema.map('user'),
            exportStartDate: twoWeeksAgo.formatMMDDYYYY(),
            exportEndDate: today.formatMMDDYYYY()
        };
    },

    computed: {
        inspectionListColumns: function inspectionListColumns() {
            return this.isAdmin ? ['inspector'] : [];
        }
    },
    methods: {
        exportInspections: function exportInspections() {
            var _this = this;

            var saveByteArray = function () {

                return function (data, name) {
                    var blob = new Blob(data, { type: "octet/stream" });

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                    } else {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.setAttribute("style", "display: none");

                        var url = URL.createObjectURL(blob);
                        a.href = url;
                        a.download = name;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                };
            }();

            this.axios.get("inspections/csv?from=" + new Date(this.exportStartDate).getTime() / 1000 + "&to=" + new Date(this.exportEndDate).getTime() / 1000).then(function (response) {
                saveByteArray([response.data], _this.exportStartDate + " to " + _this.exportEndDate + ".csv");
            });
        },
        goFilteredInspections: function goFilteredInspections(by) {
            this.$router.push({ name: 'inspections-filtered', params: { status_filter: by } });
        }
    },
    created: function created() {
        var _this2 = this;

        var self = this;

        self.axios.get('users/me').then(function (response) {
            _this2.user = response.data;
        });

        self.axios.get('stats').then(function (response) {
            self.stats = response.data;
        });

        self.axios.get('inspections?include=region,status,contact,inspector&count=' + self.recentLength).then(function (response) {
            self.inspections = response.data.data;
        });
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_role_mixins_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(77);






var inspectionsIncludeStr = 'include=status,region,contact,inspector';


/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_role_mixins_js__["a" /* default */]],
    name: 'inspection-editor',
    data: function data() {
        return {
            componentLoaded: false,
            inspection: this.$schema.map('inspection', { inspection: null })
        };
    },

    components: {
        layout: __webpack_require__(57)
    },
    methods: {
        save: function save(data) {
            var _this = this;

            this.$planner.busy(true);

            function difference(object, base) {
                function changes(object, base) {
                    return _.transform(object, function (result, value, key) {
                        if (!_.isEqual(value, base[key])) {
                            result[key] = _.isObject(value) && !Array.isArray(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
                        }
                    });
                }
                return changes(object, base);
            }

            var delta = difference(data, this.inspection.data);

            this.axios.put('inspections/' + this.inspection.id + '?' + inspectionsIncludeStr, { data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(delta) }).then(function (response) {

                _this.inspection = response.data;
                _this.$toasted.success('Inspection updated!');
                _this.$planner.busy(false);
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.$planner.busy(true);
            this.axios.post('inspections/' + this.inspection.id + '/submit?' + inspectionsIncludeStr).then(function (response) {

                _this2.inspection = response.data;
                _this2.showAlert('Inspection submitted!');
                _this2.$planner.busy(false);
            }).catch(function (error) {});
        },
        approve: function approve() {
            var _this3 = this;

            this.$planner.busy(true);
            this.axios.post('inspections/' + this.inspection.id + '/validate?' + inspectionsIncludeStr).then(function (response) {

                _this3.inspection = response.data;
                _this3.showAlert('Inspection approved!', 'Please keep a copy of the 004 for your future reference');
                _this3.$planner.busy(false);
            }).catch(function (error) {});
        },
        reject: function reject() {
            var _this4 = this;

            this.$planner.busy(true);
            this.axios.post('inspections/' + this.inspection.id + '/reject?' + inspectionsIncludeStr).then(function (response) {

                _this4.inspection = response.data;
                _this4.showAlert('Inspection rejected!');
                _this4.$planner.busy(false);
            }).catch(function (error) {});
        },
        showAlert: function showAlert(text) {
            var text2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.$swal(text, text2, 'success');
        }
    },

    created: function created() {
        var _this5 = this;

        var templateId = 'default1';

        this.axios.get('inspections/' + this.$route.params.id + '?' + inspectionsIncludeStr).then(function (response) {

            _this5.inspection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(response.data, { template_id: templateId });

            _this5.$options.components['inspection-template'] = function () {
                return __webpack_require__(867)("./inspection-" + templateId + '.vue');
            };
            _this5.componentLoaded = true;
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var _this6 = this;

        if (this.componentLoaded && this.$refs.template.hasEdits) {
            this.$swal({
                title: 'Save changes?',
                text: 'You have unsaved changes',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Save',
                cancelButtonText: 'Discard'

            }).then(function (result) {
                if (result.value) {
                    _this6.$refs.template.save();
                    next();
                } else {
                    next();
                }
            });
        } else {
            next();
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_inspections_api_mixin_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_role_mixins_js__ = __webpack_require__(67);



var mapboxgl = __webpack_require__(158);
var turfBBox = __webpack_require__(167).default;




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_inspections_api_mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_role_mixins_js__["a" /* default */]],
    name: 'inspections',
    components: {
        layout: __webpack_require__(57),
        inspectionList: __webpack_require__(357),
        pageThingy: __webpack_require__(799),
        parcelMap: __webpack_require__(370)
    },
    data: function data() {
        return {
            search: '',
            region_filter: '',
            status_filter: '',
            working: true,
            inspectionDisplayCount: 15,
            inspectionDisplayPage_1base: 1
        };
    },

    computed: {
        inspectionListColumns: function inspectionListColumns() {
            return this.isAdmin ? ['inspector', 'contact', 'delete'] : ['contact', 'delete'];
        },
        inspectionDisplaySkip: function inspectionDisplaySkip() {
            return (this.inspectionDisplayPage_1base - 1) * this.inspectionDisplayCount;
        },
        inspectionDisplayTotal: function inspectionDisplayTotal() {
            return this.inspectionsMeta.total;
        },
        parcels: function parcels() {
            var parcels = [];

            _.each(this.inspections, function (inspection) {
                _.each(inspection.parcels.data, function (parcel) {
                    parcels.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(parcel, {
                        type: "parcel",
                        inspection_id: inspection.id
                    }));
                });
            });

            return parcels;
        },
        missingMarkers: function missingMarkers() {
            var markers = [];

            _.each(this.inspections, function (inspection) {
                _.each(inspection.data.parcels.missing_parcels, function (missingParcel) {
                    markers.push({
                        type: 'missing',
                        id: Math.random().toString(36),
                        inspection_id: inspection.id,
                        position: new mapboxgl.LngLat(missingParcel.lng, missingParcel.lat)
                    });
                });
            });

            return markers;
        },
        centroids: function centroids() {
            var centroids = [];

            _.each(this.inspections, function (inspection) {
                var bounds = new mapboxgl.LngLatBounds();

                _.each(inspection.parcels.data, function (parcel) {
                    var bbox = turfBBox(JSON.parse(parcel.geom));

                    bounds.extend(new mapboxgl.LngLat(bbox[0], bbox[1]));
                    bounds.extend(new mapboxgl.LngLat(bbox[2], bbox[3]));
                });

                _.each(inspection.data.parcels.missing_parcels, function (missingParcel) {
                    bounds.extend(new mapboxgl.LngLat(missingParcel.lng, missingParcel.lat));
                });

                try {
                    centroids.push({
                        type: 'centroid',
                        id: Math.random().toString(36),
                        inspection_id: inspection.id,
                        position: new mapboxgl.LngLat(bounds.getCenter().lng, bounds.getCenter().lat)
                    });
                } catch (e) {
                    console.warn("Warning: parcel bounds did not compute: " + e.toString());
                }
            });

            return centroids;
        }
    },
    watch: {

        region_filter: function region_filter() {
            var self = this;
            this.working = true;
            this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, function () {
                self.working = false;
            });
        },

        status_filter: function status_filter() {
            var self = this;
            this.working = true;
            this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, function () {
                self.working = false;
            });
        },
        map: function map() {}
    },
    methods: {
        renderParcels: function renderParcels(inspections) {},
        onClickFeature: function onClickFeature(feature) {
            if (feature && feature.inspection_id) {
                this.$refs.parcelMap.unsetMap();
                this.$router.push('inspections/' + feature.inspection_id);
            }
        },
        getParcelCenter: function getParcelCenter(inspection) {
            if (inspection.parcel_count <= 0) return null;

            var bounds = new mapboxgl.LngLatBounds();

            _.each(inspection.parcels.data, function (parcel) {
                var geom = JSON.parse(parcel.geom);

                _.each(geom.coordinates, function (multi) {
                    _.each(multi, function (poly) {
                        _.each(poly, function (pt) {
                            var latLngObj = new mapboxgl.LngLat(pt[1], pt[0]);
                            bounds.extend(latLngObj);
                        });
                    });
                });
            });

            return bounds.getCenter();
        },
        searchInspections: function searchInspections() {
            var self = this;
            this.working = true;
            this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, function () {
                self.working = false;
            });
        },
        go: function go(page_1base) {
            this.inspectionDisplayPage_1base = page_1base;
            this.searchInspections();
        },
        deleteInspectionCheck: function deleteInspectionCheck(args) {
            var _this = this;

            var inspectionId = args[0].id;
            this.$swal({
                title: "Are you sure?",
                text: "Deletion will permanantly remove this inspection!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel'
            }).then(function (result) {
                if (result.value) {
                    return _this.axios.post("inspections/" + inspectionId + "/deactivate").then(function (result) {
                        _this.searchInspections();
                        _this.$swal('Deleted!', 'The inspection has been removed.', 'success');
                    });
                }
            });
        },
        newInspection: function newInspection() {
            var _this2 = this;

            this.createInspection().then(function (response) {
                _this2.$router.push('/inspections/' + response.data.id);
            });
        }
    },
    mounted: function mounted() {
        var self = this;

        if (this.$route.params.status_filter) {
            this.status_filter = this.$route.params.status_filter;
        }

        this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, function (inspections, meta) {
            self.working = false;
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            email: '',
            password: '',
            working: false
        };
    },

    components: {
        layout: __webpack_require__(358),
        wcInput: __webpack_require__(104)
    },
    methods: {
        attempt: function attempt() {
            var _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$toasted.error('Please enter a valid email address and password.');
                return;
            }

            this.working = true;

            this.axios.post('auth/token', {
                'email': this.email,
                'password': this.password
            }).then(function (response) {
                if (!response.data.roles || !response.data.roles.length) {
                    _this.working = false;

                    _this.$swal({
                        title: 'Insufficient Privilege',
                        text: 'Contact admin if you believe this message is in error',
                        type: "error",
                        confirmButtonText: 'OK'
                    });
                } else {
                    _this.$store.dispatch('auth/login', response.data);
                    _this.$router.push('/');
                }
            }).catch(function (error) {
                _this.working = false;
                if (error.response && error.response.status === 401) {
                    _this.$toasted.error('Login failed. Please try again.');
                }
            });
        }
    },
    validations: {
        email: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"] },
        password: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6) }
    }
});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile',
    data: function data() {
        return {
            working: true,
            user: this.$schema.map('user'),

            regions: [],
            password: null,
            repeatPassword: null
        };
    },

    validations: {
        password: {
            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(8)
        },
        repeatPassword: {
            sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('password')
        }
    },
    components: {
        layout: __webpack_require__(57)
    },
    methods: {
        updateTab: function updateTab(tab) {
            jQuery('#' + tab + '-btn').tab('show');
        },
        updateUser: function updateUser() {
            var self = this;
            this.working = true;

            if (this.password && !this.$v.$invalid || !this.password) {

                if (this.password) {
                    this.user.password = this.password;
                }

                this.axios.put('users/me', this.user).then(function (response) {
                    self.$toasted.success('User details updated!');
                }).then(function () {
                    self.working = false;
                });
            } else {
                this.$toasted.error('Password form has errors that need to be corrected.');
                this.updateTab('password');
                this.working = false;
            }
        },
        getUser: function getUser() {
            var self = this;
            this.working = true;
            this.axios.get('users/me?include=contact').then(function (response) {

                self.user = response.data;

                self.working = false;
            });
        }
    },
    created: function created() {
        var self = this;
        this.axios.get('regions').then(function (response) {
            self.regions = response.data.data;
        });

        this.getUser();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'published',
    components: {
        layout: __webpack_require__(800)
    },
    data: function data() {
        return {
            inspection: null,
            componentLoaded: false
        };
    },
    created: function created() {
        var _this = this;

        var templateId = 'default1';
        this.axios.get('inspections/published/' + this.$route.params.token + '?include=region,status,parcels,inspector,contact').then(function (response) {
            _this.inspection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(response.data, { template_id: templateId });
            _this.$options.components['inspection-template'] = function () {
                return __webpack_require__(866)("./inspection-" + _this.inspection.template_id + '-published.vue');
            };
            _this.componentLoaded = true;
        });
    }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            email: '',
            password: '',
            password_confirmation: '',
            first_name: '',
            last_name: ''
        };
    },

    components: {
        layout: __webpack_require__(358),
        wcInput: __webpack_require__(104)
    },
    methods: {
        register: function register() {
            var _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$toasted.error('Please complete all required fields.');
                return;
            }

            this.axios.post('auth/register', this.$data).then(function (response) {
                _this.$toasted.success('Registration successful! Please login.');
                _this.$router.push('login');
            });
        }
    },
    validations: {
        email: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"] },
        password: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6) },
        password_confirmation: { sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('password') },
        first_name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
        last_name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
    }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pako__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pako___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pako__);




var minipdf = function () {
    'use strict';

    var Name = function Name(name) {
        this.name = name;
    };
    function isName(obj) {
        return obj instanceof Name;
    }
    var Dict = function Dict(map) {
        this.map = map;
    };
    function isDict(obj) {
        return obj instanceof Dict;
    }
    var Stream = function Stream(map, content) {
        this.map = map;
        this.content = content;
        this.dict = new Dict(map);
    };

    Stream.prototype.getBytes = function () {
        return this.content;
    };
    function newStream(map, content) {
        assert(content instanceof Uint8Array, 'stream content must be an Uint8Array');
        return new Stream(map, content);
    }
    function isStream(obj) {
        return obj instanceof Stream;
    }
    var Ref = function Ref(num, gen) {
        this.num = num;
        this.gen = gen;
    };
    function isRef(obj) {
        return obj instanceof Ref;
    }

    function isBool(obj) {
        return typeof obj == 'boolean';
    }
    function isNull(obj) {
        return obj === null;
    }
    function isString(obj) {
        return typeof obj == 'string';
    }
    function isNum(obj) {
        return typeof obj == 'number';
    }
    function isArray(obj) {
        return obj instanceof Array;
    }

    function assert(x, msg) {
        if (x) {
            return;
        }
        if (!msg) {
            msg = 'Assertion failed';
        }
        throw new Error(msg);
    }

    function str2buf(s) {
        var uint = new Uint8Array(s.length);
        for (var i = 0, slen = s.length; i < slen; i++) {
            uint[i] = s.charCodeAt(i);
        }
        return uint;
    }

    function png_filter(content, columns) {
        var cols = columns + 1;
        var rows = content.length / cols;
        assert(rows % 1 === 0, 'Invalid column value ' + cols + ' for image width ' + content.length);
        var res = new Uint8Array(columns * rows);
        for (var y = 0; y < rows; y++) {
            var x;
            var filter = content[y * cols];

            if (filter === 0) {
                for (x = 0; x < columns; x++) {
                    res[y * columns + x] = content[y * cols + 1 + x];
                }
            } else if (filter === 2) {
                for (x = 0; x < columns; x++) {
                    var prev = y === 0 ? 0 : res[(y - 1) * columns + x];
                    res[y * columns + x] = prev + content[y * cols + 1 + x] & 0xff;
                }
            } else {
                throw new Error('Unsupported PNG filter ' + filter);
            }
        }
        return res;
    }

    function _merge_xrefs(xref_table, prev) {
        var len = Math.max(xref_table.length, prev.length);
        for (var i = 1; i < len; i++) {
            if (!prev[i]) {
                continue;
            }
            if (!xref_table[i]) {
                xref_table[i] = prev[i];
            }
        }
    }

    function inflate(content, params_map) {
        var columns;
        var predictor = 1;
        if (params_map) {
            predictor = params_map.Predictor;
            columns = params_map.Columns;
            if (params_map.Colors) {
                if (params_map.Colors != 1) {
                    throw new Error('Unsupported predictor Colors value: ' + params_map.Colors);
                }
            }
            if (params_map.BitsPerComponent) {
                if (params_map.BitsPerComponent != 8) {
                    throw new Error('Unsupported predictor BitsPerComponent value: ' + params_map.BitsPerComponent);
                }
            }
        }

        var res = __WEBPACK_IMPORTED_MODULE_2_pako___default.a.inflate(content);
        if (predictor == 1) {
            return res;
        }

        assert(columns > 0, 'columns must be set for PNG predictors');

        if (predictor >= 10 && predictor <= 15) {
            res = png_filter(res, columns);
        } else {
            throw new Error('Unsupported predictor ' + predictor);
        }
        return res;
    }

    function parse(buf) {
        return new PDFDocument(buf);
    }

    var PDFDocument = function PDFDocument(buf) {
        this._cached_object_streams = {};

        this.buf = buf;
        this.reader = new PDFReader(buf);

        check_header(buf);
        this.startxref = find_startxref(buf);
        this.reader.pos = this.startxref;

        var xref_res = this.reader.parse_xref();
        this.xref = xref_res.xref;
        assert(isArray(this.xref));
        this.meta = xref_res.meta;
        assert(this.meta.Root, 'meta.Root missing');
        assert(isRef(this.meta.Root), 'meta.root should be Ref');

        this.root = this.fetch(this.meta.Root);
        this.xref_type = this.reader.xref_type;

        var af_node = this.get_acroform_ref();
        if (isRef(af_node)) {
            this.acroForm = this.fetch(af_node);
        } else {
            this.acroForm = af_node;
        }
    };
    PDFDocument.prototype.get_root_id = function () {
        return this.meta.Root.num;
    };
    PDFDocument.prototype.get_xref_entries = function () {
        return this.xref;
    };
    PDFDocument.prototype.get_acroform_ref = function () {
        return this.root.map.AcroForm;
    };
    PDFDocument.prototype.fetch = function (ref, recursive) {
        assert(ref instanceof Ref);

        var xref_entry = this.xref[ref.num];
        if (!xref_entry) {
            throw new Error('Cannot find object ' + ref.num + ' in xref table');
        }
        if (xref_entry.type === 0) {
            throw new Error('Cannot fetch a free object');
        }
        if (xref_entry.type == 2) {
            if (recursive) {
                throw new Error('Cannot fetch object stream inside object stream');
            }
            if (ref.gen !== 0) {
                throw new Error('Object with reference ' + ref.gen + ' cannot be found in object stream');
            }
            var object_stream = this._cached_object_streams[xref_entry.offset];
            if (!object_stream) {
                var object_stream_obj = this.fetch(new Ref(xref_entry.offset, 0), true);
                object_stream = parse_object_stream(object_stream_obj);
                this._cached_object_streams[xref_entry.offset] = object_stream;
            }
            if (!(ref.num in object_stream)) {
                throw new Error('Could not find object ' + ref.num + ' in object stream with entries ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object_stream)));
            }
            var res = object_stream[ref.num];
            return res;
        }
        if (ref.gen != xref_entry.gen) {
            throw new Error('Invalid generation: Asked for ' + ref.gen + ', table has ' + xref_entry.gen);
        }
        this.reader.pos = xref_entry.offset;

        var obj = this.reader.parse_object();
        if (obj.num !== ref.num) {
            throw new Error('Expected to read object with ID ' + ref.num + ', but found ' + obj.num);
        }
        if (obj.gen !== ref.gen) {
            throw new Error('Expected to read object with gen ' + ref.gen + ', but found ' + obj.gen);
        }
        return obj.obj;
    };

    var PDFReader = function PDFReader(buf) {
        assert(buf instanceof Uint8Array, 'Expected a buffer of type Uint8Array');
        assert(buf.BYTES_PER_ELEMENT === 1, 'not a Uint8Array!');
        this.buf = buf;
        this.pos = 0;
    };
    PDFReader.prototype = {
        skip_space: function skip_space() {
            while (this.pos < this.buf.length) {
                var c = this.buf[this.pos];
                if (c == 9 || c == 10 || c == 13 || c == 32) {
                    this.pos++;
                } else {
                    break;
                }
            }
        },
        skip_start: function skip_start(str) {
            if (startswith(this.buf, this.pos, str)) {
                this.pos += str.length;
                return true;
            }
            return false;
        },
        read_uint: function read_uint(len) {
            var res = 0;
            while (len > 0) {
                assert(this.buf[this.pos] !== undefined, 'reading uint at position ' + this.pos + ' of ' + this.buf.length);
                res = (res << 8 | this.buf[this.pos] & 0xff) >>> 0;
                this.pos++;
                len--;
            }
            return res;
        },
        parse_string: function parse_string() {
            var res = '';
            var parens = 1;
            while (this.pos < this.buf.length) {
                var c = String.fromCharCode(this.buf[this.pos]);

                this.pos++;
                if (c == ')') {
                    parens--;
                    if (parens === 0) {
                        break;
                    }
                    res += c;
                } else if (c == '(') {
                    parens++;
                    res += c;
                } else if (c == '\\') {
                    c = String.fromCharCode(this.buf[this.pos]);

                    this.pos++;
                    switch (c) {
                        case 'n':
                            res += '\n';
                            break;
                        case 'r':
                            res += '\r';
                            break;
                        case 't':
                            res += '\t';
                            break;
                        case '0':
                        case '\r':
                        case '\n':
                            break;
                        case '\\':
                        case '(':
                        case ')':
                            res += c;
                            break;
                        default:
                            throw new Error('Unsupported escape "' + c + '"');
                    }
                } else {
                    res += c;
                }
            }

            return res;
        },
        parse_hex_string: function parse_hex_string() {
            var start_pos = this.pos;
            while (this.pos < this.buf.length) {
                if (this.buf[this.pos] == '>'.charCodeAt(0)) {
                    break;
                }
                this.pos++;
            }
            var hex_str = buf2str(this.buf, start_pos, this.pos);
            this.pos++;
            if (hex_str.length % 2 == 1) {
                hex_str += '0';
            }
            if (!/^[0-9A-Fa-f]*$/.test(hex_str)) {
                throw new Error('Invalid hex string ' + hex_str);
            }
            return hex_str.replace(/([0-9A-Fa-f]{2})/g, function () {
                return String.fromCharCode(parseInt(arguments[1], 16));
            });
        },
        parse_num: function parse_num() {
            var res = 0;
            var first_pos = this.pos;
            while (this.pos < this.buf.length) {
                var by = this.buf[this.pos];
                if (48 <= by && by <= 57) {
                    res = res * 10 + by - 48;
                } else {
                    break;
                }
                this.pos++;
            }
            if (first_pos === this.pos) {
                throw new Error('Not an ASCII number byte: ' + this.buf[this.pos]);
            }
            return res;
        },
        parse_name: function parse_name() {
            var start_pos = this.pos;
            var DELIM_CHARS = [0, 9, 13, 10, 32, 40, 41, 60, 62, 91, 93, 123, 125, 47, 37];
            while (this.pos < this.buf.length) {
                if (DELIM_CHARS.indexOf(this.buf[this.pos]) >= 0) {
                    break;
                }
                this.pos++;
            }
            var name = buf2str(this.buf, start_pos, this.pos);
            name = name.replace(/#([0-9a-fA-F]{2})/g, function (_, hex) {
                return String.fromCharCode(parseInt(hex, 16));
            });
            return new Name(name);
        },
        parse_array: function parse_array() {
            var res = [];
            for (;;) {
                this.skip_space();
                if (this.buf[this.pos] == 93) {
                    break;
                }
                var el = this.parse();
                res.push(el);
            }
            this.pos++;
            return res;
        },
        parse_dict: function parse_dict() {
            var map = {};
            while (this.pos < this.buf.length) {
                this.skip_space();
                if (this.skip_start('>>')) {
                    break;
                }
                if (!this.skip_start('/')) {
                    throw new Error('Key is not a name in dict');
                }
                var k = this.parse_name();
                var v = this.parse();
                map[k.name] = v;
            }
            var sav_pos = this.pos;
            this.skip_space();
            if (this.skip_start('stream\r\n') || this.skip_start('stream\n') || this.skip_start('stream')) {
                return this.parse_stream_content(map);
            } else {
                this.pos = sav_pos;
                return new Dict(map);
            }
        },
        parse_stream_content: function parse_stream_content(map) {
            if (typeof map.Length != 'number') {
                throw new Error('Stream Length field missing or invalid: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(map.Length));
            }
            if (this.pos + map.Length > this.buf.length) {
                throw new Error('Stream Length too large');
            }
            var content = this.buf.subarray(this.pos, this.pos + map.Length);
            this.pos += map.Length;
            this.skip_space();
            if (!this.skip_start('endstream')) {
                throw new Error('Missing endstream');
            }
            if (map.Filter) {
                var filters = map.Filter instanceof Array ? map.Filter : [map.Filter];
                var params = map.DecodeParms instanceof Array ? map.DecodeParms : [map.DecodeParms];
                for (var i = 0; i < filters.length; i++) {
                    var filter_params = params[i];

                    switch (filters[i].name) {
                        case 'FlateDecode':
                            content = inflate(content, filter_params ? filter_params.map : filter_params);
                            break;
                        default:
                            throw new Error('Unsupported filter: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filters[i].name));
                    }
                }
            }

            return new Stream(map, content);
        },
        parse: function parse() {
            this.skip_space();
            if (this.skip_start('<<')) {
                return this.parse_dict();
            }
            if (this.skip_start('[')) {
                return this.parse_array();
            }
            if (this.skip_start('(')) {
                return this.parse_string();
            }
            if (this.skip_start('<')) {
                return this.parse_hex_string();
            }
            if (this.skip_start('/')) {
                return this.parse_name();
            }

            if (this.skip_start('true')) {
                return true;
            }
            if (this.skip_start('false')) {
                return false;
            }
            if (this.skip_start('null')) {
                return null;
            }

            var s = buf2str(this.buf, this.pos, this.pos + 32);
            var m = /^([0-9]+)\s+([0-9]+)\s+R/.exec(s);
            if (m) {
                this.pos += m[0].length;
                return new Ref(parseInt(m[1], 10), parseInt(m[2], 10));
            }
            m = /^[+-]?(?:[0-9]*\.[0-9]*|[0-9]+)/.exec(s);
            if (m) {
                this.pos += m[0].length;
                return parseFloat(m[0]);
            }

            throw new Error('Unable to parse ' + buf2str(this.buf, this.pos, this.pos + 40));
        },
        parse_xref: function parse_xref() {
            if (startswith(this.buf, this.pos, 'xref')) {
                this.xref_type = 'table';
                return this.parse_xref_table();
            }
            this.xref_type = 'stream';
            var obj = this.parse_object().obj;
            var xref = [];

            if ('Prev' in obj.map) {
                var sav_pos = this.pos;
                this.pos = obj.map.Prev;
                xref = this.parse_xref().xref;
                this.pos = sav_pos;
            }

            assert(obj instanceof Stream, 'XRefs should be a stream, got ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) + ' instead');
            assert(obj.map.Type.name === 'XRef', 'XRef table should be of Type XRef');
            assert(obj.map.W.length == 3);
            var type_length = obj.map.W[0];
            assert(type_length <= 4);
            var offset_length = obj.map.W[1];
            assert(offset_length >= 1 && offset_length <= 4);
            var gen_length = obj.map.W[2];
            assert(gen_length >= 1 && gen_length <= 4);
            assert(obj.content.length % (type_length + offset_length + gen_length) === 0, 'content is ' + obj.content.length + ' bytes long, each entry is ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj.map.W));

            var first_index = 0;
            if (obj.map.Index) {
                first_index = obj.map.Index[0];
                assert(typeof first_index == 'number');
            }

            var count = obj.content.length / (type_length + offset_length + gen_length);
            if (obj.map.Index) {
                assert(obj.map.Index[1] == count, 'Invalid xref stream index: index says ' + obj.map.Index[1] + ' objects, but space for ' + count);
            }
            var reader = new PDFReader(obj.content);
            for (var i = 0; i < count; i++) {
                var type = 1;
                if (type_length) {
                    type = reader.read_uint(type_length);
                }
                var offset = reader.read_uint(offset_length);
                var gen = reader.read_uint(gen_length);
                xref[first_index + i] = {
                    uncompressed: type != 2,
                    type: type,
                    offset: offset,
                    gen: gen
                };
            }
            assert(reader.at_eof());

            return {
                meta: obj.map,
                xref: xref
            };
        },
        parse_object: function parse_object() {
            var s = buf2str(this.buf, this.pos, this.pos + 32);
            var m = /^([0-9]+)\s+([0-9]+)\s+obj/.exec(s);
            if (!m) {
                throw new Error('Missing object ID: ' + s);
            }
            var real_num = parseInt(m[1], 10);
            var real_gen = parseInt(m[2], 10);
            this.pos += m[0].length;
            var obj = this.parse();
            this.skip_space();
            if (!this.skip_start('endobj')) {
                throw new Error('endobj missing, current str: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(buf2str(this.buf, this.pos, this.pos + 32)));
            }
            return {
                obj: obj,
                num: real_num,
                gen: real_gen
            };
        },
        parse_xref_table: function parse_xref_table() {
            if (!this.skip_start('xref')) {
                throw new Error('xref table does not start with xref!');
            }
            this.skip_space();
            var start_num = this.parse_num();
            var xref = [];
            for (var j = 0; j < start_num; j++) {
                xref.push(undefined);
            }
            this.skip_space();
            this.parse_num();
            for (;;) {
                this.skip_space();
                if (this.skip_start('trailer')) {
                    break;
                }
                var offset = this.parse_num();
                this.skip_space();
                var gen = this.parse_num();
                this.skip_space();
                var usage = this.buf[this.pos];
                if (usage == 102 || usage == 110) {
                    this.pos++;
                } else {
                    while (xref.length < offset) {
                        xref.push(undefined);
                    }
                    continue;
                }
                xref.push({
                    offset: offset,
                    gen: gen,
                    is_free: usage === 102
                });
            }

            var meta = this.parse();
            if (meta.map.Prev) {
                this.pos = meta.map.Prev;
                var old = this.parse_xref_table();
                _merge_xrefs(xref, old.xref);
            }

            return {
                xref: xref,
                meta: meta.map
            };
        },
        at_eof: function at_eof() {
            return this.pos == this.buf.length;
        }
    };

    function startswith(buf, pos, str) {
        for (var i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) != buf[pos + i]) {
                return false;
            }
        }
        return true;
    }

    function buf2str(buf, from, to) {
        if (from === undefined) {
            from = 0;
        }
        if (to === undefined) {
            to = buf.length;
        }
        var max = Math.min(to, buf.length);

        var res = '';
        for (var i = from; i < max; i++) {
            res += String.fromCharCode(buf[i]);
        }
        return res;
    }

    function check_header(buf) {
        if (!startswith(buf, 0, '%PDF-')) {
            throw new Error('Does not look like a PDF file!');
        }
    }

    function find_startxref(buf) {
        var s = buf2str(buf, buf.length - 40, buf.length);
        var m = /startxref\s*([0-9]+)/.exec(s);
        if (!m) {
            throw new Error('Cannot find startxref!');
        }
        return parseInt(m[1]);
    }

    function parse_object_stream(os_obj) {
        assert(os_obj.map.Type.name === 'ObjStm', 'Strange Type for an object stream: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(os_obj.map.Type.name));
        var s = buf2str(os_obj.content, 0, os_obj.map.First);
        var rex = /\s*([0-9]+)\s+([0-9]+)/g;
        var res = [];
        var r = new PDFReader(os_obj.content);
        for (var i = 0; i < os_obj.map.N; i++) {
            var m = rex.exec(s);
            if (!m) {
                throw new Error('Expected ' + os_obj.map.N + ' objects in this object stream, failed to read number ' + i);
            }
            var num = parseInt(m[1], 10);
            var offset = parseInt(m[2], 10);
            r.pos = offset + os_obj.map.First;
            res[num] = r.parse();
        }

        return res;
    }

    return {
        parse: parse,
        PDFDocument: PDFDocument,
        isName: isName,
        isStream: isStream,
        isDict: isDict,
        isRef: isRef,
        isNum: isNum,
        isArray: isArray,
        isString: isString,
        isBool: isBool,
        isNull: isNull,
        newStream: newStream,
        assert: assert,
        buf2str: buf2str,
        str2buf: str2buf,

        PDFReader: PDFReader,
        Name: Name,
        Dict: Dict,
        Ref: Ref,
        Stream: Stream
    };
}();

/* harmony default export */ __webpack_exports__["a"] = (minipdf);

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/* harmony default export */ __webpack_exports__["a"] = ({
    busy: function busy(active) {
        var busy = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#busy');
        active ? busy.removeClass('hidden') : busy.addClass('hidden');
    },
    loader: function loader(mode) {
        var loader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#page-loader');

        if (mode === 'show') {
            if (loader.length) {
                loader.fadeIn(250);
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').prepend('<div id="page-loader"></div>');
            }
        } else if (mode === 'hide') {
            if (loader.length) {
                loader.fadeOut(250);
            }
        }
    },
    init: function init() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', '[data-toggle="block-option"]', function () {
            var btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            var block = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.block');

            switch (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('action')) {
                case 'content_toggle':
                    block.toggleClass('block-opt-hidden');
                    if (block.hasClass('block-opt-hidden')) {
                        btn.find('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                    } else {
                        btn.find('i').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                    }
                    break;
            }
        });
    },
    nl2br: function nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    capitalize: function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var timestamp = {
    date: null,
    timezone: 'UTC',
    timezone_type: 3
};

var country = {
    id: null,
    abbr: null,
    name: null
};

var region = {
    id: null,
    abbr: null,
    name: null,
    country: _.clone(country)
};

var landowner = {
    id: null,
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    company: null,
    address: null,
    locality: null,
    region_id: null,
    postal_code: null,
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

var property = {
    id: null,
    pid: null,
    geom: null,
    region: _.cloneDeep(region)
};

var plan = {
    id: null,
    data: null,

    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

var contact = {
    first_name: null,
    middle_name: null,
    last_name: null,
    email: null,
    phone: null,
    company: null,
    address: null,
    locality: null,
    postal_code: null,
    region_id: null,
    region: _.clone(region)
};

var user = {
    id: null,

    email: null,

    roles: null,
    contact: _.clone(contact),
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

var inspector = {
    user: _.clone(user),
    inspector_license: null,
    inspections: {
        data: []
    }
};

var status = {
    id: null,
    typename: null,
    name: null
};

var inspection = {
    id: null,
    token: null,
    region_id: null,
    parcels: null,
    inspector: _.clone(inspector),
    user: _.clone(user),
    status: _.clone(status),
    region: _.clone(region),
    contact: _.clone(contact),
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

var models = {
    country: country,
    region: region,
    landowner: landowner,
    property: property,
    plan: plan,
    user: user,
    contact: contact,
    inspector: inspector,
    inspection: inspection
};

function mapRelationships(map) {
    var relationships = {};

    _.forIn(map, function (v, k) {
        if (models.hasOwnProperty(k)) {
            var r = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, k, _.cloneDeep(models[k]));

            if (_.isObject(v)) {
                r[k] = _.assign(r[k], mapRelationships(v));
            }

            relationships = _.assign(relationships, r);
        }
    });

    return relationships;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    map: function map(base) {
        var relationships = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!models.hasOwnProperty(base)) {
            console.error('Invalid base model name.');
            return;
        }

        return _.assign(_.cloneDeep(models[base]), mapRelationships(relationships));
    },
    getTimestamp: function getTimestamp() {
        return _.clone(timestamp);
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(833);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'login',
        component: __webpack_require__(806),
        meta: {
            guest: true
        }
    }, {
        path: '/published/:token',
        name: 'published',
        component: __webpack_require__(808),
        meta: {
            guest: true
        }
    }, {
        path: '/register',
        name: 'register',
        component: __webpack_require__(809),
        meta: {
            guest: false,
            roles: ['admin']
        }
    }, {
        path: '/',
        name: 'home',
        component: __webpack_require__(804),
        meta: {
            guest: false,
            roles: ['admin']
        }
    }, {
        path: '/help',
        name: 'help',
        component: __webpack_require__(803),
        meta: {
            guest: false,
            roles: ['admin', 'inspector']
        }
    }, {
        path: '/foresters',
        name: 'foresters',
        component: __webpack_require__(802),
        meta: {
            guest: false,
            roles: ['admin']
        }
    }, {
        path: '/foresters/:id',
        name: 'foresters-single',
        component: __webpack_require__(801),
        meta: {
            guest: false,
            roles: ['admin']
        }
    }, {
        path: '/inspections',
        name: 'inspections',
        component: __webpack_require__(359),
        meta: {
            guest: false,
            roles: ['admin', 'inspector']
        }
    }, {
        path: '/inspections',
        name: 'inspections-filtered',
        component: __webpack_require__(359),
        meta: {
            guest: false,
            roles: ['admin', 'inspector']
        }
    }, {
        path: '/inspections/:id',
        name: 'inspections-editor',
        component: __webpack_require__(805),
        meta: {
            guest: false,
            roles: ['admin', 'inspector']
        }
    }, {
        path: '/profile',
        name: 'profile',
        component: __webpack_require__(807),
        meta: {
            guest: false,
            roles: ['admin', 'inspector']
        }
    }]
}));

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(463);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */]
    }
}));

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        authenticated: false
    },
    mutations: {
        init: function init(state) {
            state.authenticated = !!localStorage.getItem('auth_token');
            state.roles = localStorage.getItem('auth_roles');

            if (!state.roles) {
                state.roles = [];
            }

            if (state.authenticated) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('auth_token');
            }
        },
        login: function login(state, responseData) {
            state.authenticated = true;
            state.roles = responseData.roles;

            localStorage.setItem('auth_token', responseData.token);
            localStorage.setItem('auth_roles', responseData.roles);
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('auth_token');
        },
        logout: function logout(state) {
            state.authenticated = false;
            state.roles = [];

            localStorage.removeItem('auth_token');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common.Authorization = '';
        }
    },
    actions: {
        init: function init(context) {
            context.commit('init');
        },
        login: function login(context, responseData) {
            context.commit('login', responseData);
        },
        logout: function logout(context) {
            context.commit('logout');
        }
    }
});

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  "data-v-8b9dbc28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        isAdmin: function isAdmin() {
            return this.roles.indexOf(this.ROLE_ADMIN) >= 0;
        },
        isInspector: function isInspector() {
            return this.roles.indexOf(this.ROLE_INSPECTOR) >= 0;
        },
        isLeadingAdmin: function isLeadingAdmin() {
            return this.isAdmin;
        },
        isLeadingInspector: function isLeadingInspector() {
            return this.isInspector && !this.isAdmin;
        }
    },
    created: function created() {
        var self = this;

        this.$store.subscribe(function (mutation, state) {

            self.roles = state.auth.roles;
        });

        if (this.$store.state.auth) {
            this.roles = this.$store.state.auth.roles;
        }
    },
    data: function data() {
        return {
            roles: [],
            ROLE_ADMIN: 'admin',
            ROLE_INSPECTOR: 'inspector'
        };
    }
});

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 221,
	"./af.js": 221,
	"./ar": 228,
	"./ar-dz": 222,
	"./ar-dz.js": 222,
	"./ar-kw": 223,
	"./ar-kw.js": 223,
	"./ar-ly": 224,
	"./ar-ly.js": 224,
	"./ar-ma": 225,
	"./ar-ma.js": 225,
	"./ar-sa": 226,
	"./ar-sa.js": 226,
	"./ar-tn": 227,
	"./ar-tn.js": 227,
	"./ar.js": 228,
	"./az": 229,
	"./az.js": 229,
	"./be": 230,
	"./be.js": 230,
	"./bg": 231,
	"./bg.js": 231,
	"./bm": 232,
	"./bm.js": 232,
	"./bn": 233,
	"./bn.js": 233,
	"./bo": 234,
	"./bo.js": 234,
	"./br": 235,
	"./br.js": 235,
	"./bs": 236,
	"./bs.js": 236,
	"./ca": 237,
	"./ca.js": 237,
	"./cs": 238,
	"./cs.js": 238,
	"./cv": 239,
	"./cv.js": 239,
	"./cy": 240,
	"./cy.js": 240,
	"./da": 241,
	"./da.js": 241,
	"./de": 244,
	"./de-at": 242,
	"./de-at.js": 242,
	"./de-ch": 243,
	"./de-ch.js": 243,
	"./de.js": 244,
	"./dv": 245,
	"./dv.js": 245,
	"./el": 246,
	"./el.js": 246,
	"./en-au": 247,
	"./en-au.js": 247,
	"./en-ca": 248,
	"./en-ca.js": 248,
	"./en-gb": 249,
	"./en-gb.js": 249,
	"./en-ie": 250,
	"./en-ie.js": 250,
	"./en-il": 251,
	"./en-il.js": 251,
	"./en-nz": 252,
	"./en-nz.js": 252,
	"./eo": 253,
	"./eo.js": 253,
	"./es": 256,
	"./es-do": 254,
	"./es-do.js": 254,
	"./es-us": 255,
	"./es-us.js": 255,
	"./es.js": 256,
	"./et": 257,
	"./et.js": 257,
	"./eu": 258,
	"./eu.js": 258,
	"./fa": 259,
	"./fa.js": 259,
	"./fi": 260,
	"./fi.js": 260,
	"./fo": 261,
	"./fo.js": 261,
	"./fr": 264,
	"./fr-ca": 262,
	"./fr-ca.js": 262,
	"./fr-ch": 263,
	"./fr-ch.js": 263,
	"./fr.js": 264,
	"./fy": 265,
	"./fy.js": 265,
	"./gd": 266,
	"./gd.js": 266,
	"./gl": 267,
	"./gl.js": 267,
	"./gom-latn": 268,
	"./gom-latn.js": 268,
	"./gu": 269,
	"./gu.js": 269,
	"./he": 270,
	"./he.js": 270,
	"./hi": 271,
	"./hi.js": 271,
	"./hr": 272,
	"./hr.js": 272,
	"./hu": 273,
	"./hu.js": 273,
	"./hy-am": 274,
	"./hy-am.js": 274,
	"./id": 275,
	"./id.js": 275,
	"./is": 276,
	"./is.js": 276,
	"./it": 277,
	"./it.js": 277,
	"./ja": 278,
	"./ja.js": 278,
	"./jv": 279,
	"./jv.js": 279,
	"./ka": 280,
	"./ka.js": 280,
	"./kk": 281,
	"./kk.js": 281,
	"./km": 282,
	"./km.js": 282,
	"./kn": 283,
	"./kn.js": 283,
	"./ko": 284,
	"./ko.js": 284,
	"./ky": 285,
	"./ky.js": 285,
	"./lb": 286,
	"./lb.js": 286,
	"./lo": 287,
	"./lo.js": 287,
	"./lt": 288,
	"./lt.js": 288,
	"./lv": 289,
	"./lv.js": 289,
	"./me": 290,
	"./me.js": 290,
	"./mi": 291,
	"./mi.js": 291,
	"./mk": 292,
	"./mk.js": 292,
	"./ml": 293,
	"./ml.js": 293,
	"./mn": 294,
	"./mn.js": 294,
	"./mr": 295,
	"./mr.js": 295,
	"./ms": 297,
	"./ms-my": 296,
	"./ms-my.js": 296,
	"./ms.js": 297,
	"./mt": 298,
	"./mt.js": 298,
	"./my": 299,
	"./my.js": 299,
	"./nb": 300,
	"./nb.js": 300,
	"./ne": 301,
	"./ne.js": 301,
	"./nl": 303,
	"./nl-be": 302,
	"./nl-be.js": 302,
	"./nl.js": 303,
	"./nn": 304,
	"./nn.js": 304,
	"./pa-in": 305,
	"./pa-in.js": 305,
	"./pl": 306,
	"./pl.js": 306,
	"./pt": 308,
	"./pt-br": 307,
	"./pt-br.js": 307,
	"./pt.js": 308,
	"./ro": 309,
	"./ro.js": 309,
	"./ru": 310,
	"./ru.js": 310,
	"./sd": 311,
	"./sd.js": 311,
	"./se": 312,
	"./se.js": 312,
	"./si": 313,
	"./si.js": 313,
	"./sk": 314,
	"./sk.js": 314,
	"./sl": 315,
	"./sl.js": 315,
	"./sq": 316,
	"./sq.js": 316,
	"./sr": 318,
	"./sr-cyrl": 317,
	"./sr-cyrl.js": 317,
	"./sr.js": 318,
	"./ss": 319,
	"./ss.js": 319,
	"./sv": 320,
	"./sv.js": 320,
	"./sw": 321,
	"./sw.js": 321,
	"./ta": 322,
	"./ta.js": 322,
	"./te": 323,
	"./te.js": 323,
	"./tet": 324,
	"./tet.js": 324,
	"./tg": 325,
	"./tg.js": 325,
	"./th": 326,
	"./th.js": 326,
	"./tl-ph": 327,
	"./tl-ph.js": 327,
	"./tlh": 328,
	"./tlh.js": 328,
	"./tr": 329,
	"./tr.js": 329,
	"./tzl": 330,
	"./tzl.js": 330,
	"./tzm": 332,
	"./tzm-latn": 331,
	"./tzm-latn.js": 331,
	"./tzm.js": 332,
	"./ug-cn": 333,
	"./ug-cn.js": 333,
	"./uk": 334,
	"./uk.js": 334,
	"./ur": 335,
	"./ur.js": 335,
	"./uz": 337,
	"./uz-latn": 336,
	"./uz-latn.js": 336,
	"./uz.js": 337,
	"./vi": 338,
	"./vi.js": 338,
	"./x-pseudo": 339,
	"./x-pseudo.js": 339,
	"./yo": 340,
	"./yo.js": 340,
	"./zh-cn": 341,
	"./zh-cn.js": 341,
	"./zh-hk": 342,
	"./zh-hk.js": 342,
	"./zh-tw": 343,
	"./zh-tw.js": 343
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-complete.855deb0.png";

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/missing-parcel-marker.d125657.png";

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABwCAMAAABRoWyXAAAA/1BMVEUAAAAEAQEGAgIJAgMOBAURBQUTBQYXBwgYBwgZBwkcCAofCQshCgwpDA4uDRAxDhEzDxI2EBM6ERU+ExZAExdDFBhFFRhJFhpNFxtQGBxUGR5YGh9dHCFiHSNnHyRpICVsISdvIShwIihxIih3JCp6JSt+Ji2AJy6IKTCMKjKQKzOTLDSVLTWZLjaeMDiiMTqlMjuoMzysND2wNT+0NkC2N0G4N0G7OEO9OUPJPUjKQk3MS1XNTljOUFrRXGTUZm7WbHTXdHvafoTdiI3fjpPfkJXgk5jjnqLkoKTlpannq67nrrDosLPrvL7svsDtw8Tvysvwzc7z2tn57ev+//zzkMFzAAAAOXRSTlMABQkMEhYZHh8hJCgrNDo+QUVLUFJWWV1jZmtxd32DhoqOj5GZnKCkrbK4vL7Cyc7T1tvg5enq7vHP/E62AAADpklEQVRoge2ZW1vaQBCGw8Ejxiq0VRSUalWwYEFQWLCA2AOtFSzk//+WJsQDZL/ZU/L0qt8tw/vsZGZnZ2ct67/+leIrazMtxyKAJTbe5ouVemOmy/JpLr0eBhu3c+VrFlCjlE0ZQpO7pWYQ5+uqmEma8C4wztdFNqEJ3P4k4nk6T+vwlgotGZCx1tGyMtAuy3meKrYicKeuBmSs/l4NSEQYer4bMVAJqQdUQKY1gYw1t4XA9aoukLFaSgBMFPWBjBUF22fPBMjYPglMXZoR6xsU8aMZkLETAmhztVBVzU1MPDEFMnYKgRtX9D863V6v26F/v4ZfMkeZt/v3k6mrye9+m7LJA2CiQhj3Rs6Lxj3C6ALkpE0U2cHUmdN0gK1aIDaE04tAGgncxhuwHwC6yD40LHEnbhLWiM5jEOg4f2DMa0tBYgqm9x0PdJw7ZMnnTxqZtceI+AhzKBMkZpBVl/uKsy/ZRbbvlEJ9i4COc4tsuWAXkNVXTPyObI+CxENk9U2D+EGJOMBEGGyOCL3uwcg4MMc5IjxiOhMEnNwg26xS9rAhIv6Eplz2bMLSgxISp2PrTZC4ihuyHzxxCA3rK0FiHPeMnVEQOMaHQzkeJOL0YewmsLXHX7AdF2q3VBA1/ObX3Lec3hNAvlC4vTfZRPUfnpjTB1xtXdVQT35MWbN2dzAcjYaDLnkUsgIAWpvareOr0MFlWbGSOfEM3+syCpcYYolcevtKGC+SWKL5l6SWKAy32RLdxl75tqW4RMvKR7xEd+N81gc2xPfNrD6xIARaiXNdYHVVTLS2dDNIftXUzKCSfF6xohUcSVh87egQcwpAK3aqDqxwfSjUek0V2NxSAmr4faAIVPZb0WdPKaWKoeyzp/1IffakUs41fPZkS/1ugTNfKKnfx5pAKymZxklLDi9JEVIZmAV1JAIqlBxeos2oVHJ4CTajViq+ij4hqurz1kWRwTEJiy9iAmQUFl+4Ygh7CJlguy/sIWRCGWSYOc8C18VCKKC1zJ21DXLYaLrIkEvku7XQS+RGIqGXGMzJZrhA+1rIyVC5+Cx7bne3tJ55SJ29EsvmO3pec3cxbrxhpuTLG9ql/nGF9ZJA2icqpefRe6gytqDY00S2Ek1cPGV9Ihp6GyrVmDlNvB6YyHc7Qqef3I7QadftK9dpnZZWKm8GVtXrQGXKU28wxkozthctcbXeiqLWzil2XjV4qBfq4CxioJWhnxkNtRbxZ3QVxZFlqL81WqcvZT6EvgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  "data-v-e5ad934e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  "data-v-76304229",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-09fced45",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 810:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "0 auto"
    }
  }, [(_vm.componentLoaded) ? _c('div', {
    staticClass: "text-center text-white push-30"
  }) : _vm._e(), _vm._v(" "), (_vm.componentLoaded) ? _c("inspection-template", {
    tag: "component",
    attrs: {
      "inspection": _vm.inspection
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [(_vm.componentLoaded) ? _c("inspection-template", {
    ref: "template",
    tag: "component",
    attrs: {
      "inspection": _vm.inspection
    },
    on: {
      "save": _vm.save,
      "submit": _vm.submit,
      "approve": _vm.approve,
      "reject": _vm.reject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image bg-trees full-height",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "block block-rounded animated fadeIn push-50-t",
    attrs: {
      "id": "registration-container"
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full block-content-narrow"
  }, [_c('h1', {
    staticClass: "h2 font-w600 push-20-t push-50"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(790),
      "height": "58"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Please fill the following details to create a new forester account.")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal push-30-t push-30",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('wc-input', {
    attrs: {
      "label": "First Name"
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('wc-input', {
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = $$v
      },
      expression: "last_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password Confirmation"
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = $$v
      },
      expression: "password_confirmation"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                            Create Account\n                                        ")])])])])])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "bg-image"
  }, [_c('div', {
    staticClass: "block-content bg-primary-op text-center overflow-hidden"
  }, [_c('div', {
    staticClass: " push animated fadeInDown"
  }, [_c('div', {
    staticClass: "item item-2x item-circle bg-crystal-op push-20-t push-20"
  }, [_c('i', {
    staticClass: "icon-user text-white-op"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "push-30 animated fadeInUp"
  }, [_c('h2', {
    staticClass: "h4 font-w600 text-white push-5"
  }, [_vm._v(_vm._s(_vm.user.contact.first_name + ' ' + _vm.user.contact.last_name))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-justified push-20",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab-profile-personal",
      "id": "personal-btn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTab('personal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  }), _vm._v(" Personal")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab-profile-password",
      "id": "password-btn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTab('password')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-asterisk"
  }), _vm._v(" Password")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "tab-profile-personal"
    }
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-3 form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.first_name),
      expression: "user.contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("First Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.middle_name),
      expression: "user.contact.middle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.middle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "middle_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Middle Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.last_name),
      expression: "user.contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Last Name")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Email")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.phone),
      expression: "user.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Phone")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.company),
      expression: "user.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "company"
    },
    domProps: {
      "value": (_vm.user.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Company")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.address),
      expression: "user.contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Address")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.postal_code),
      expression: "user.contact.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "postal_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Zip Code")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.locality),
      expression: "user.contact.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.contact.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.contact, "locality", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("City")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact.region_id),
      expression: "user.contact.region_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.contact, "region_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('option', {
      domProps: {
        "value": region.id
      }
    }, [_vm._v(_vm._s(region.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("State")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tab-profile-password"
    }
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-3 form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.password.$error
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "profile-password-new"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }, function($event) {
        _vm.$v.password.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.password.minLength) ? _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [_vm._v("Password must have at least " + _vm._s(_vm.$v.password.$params.minLength.min) + " letters.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.repeatPassword.$error
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "profile-password-new-confirm"
    }
  }, [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.repeatPassword),
      expression: "repeatPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value.trim()
      }, function($event) {
        _vm.$v.repeatPassword.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.repeatPassword.sameAsPassword) ? _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.updateUser
    }
  }, [_c('i', {
    staticClass: "fa fa-check push-5-r"
  }), _vm._v(" Save Changes")])])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wc-input-wrapper control-label",
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'has-awesome': _vm.isAwesome
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    class: {
      'i-am-sunny': _vm.disabled
    },
    attrs: {
      "rows": _vm.rows,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.update,
      "blur": _vm.touch
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wc-input-wrapper",
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: {
      'i-am-sunny': _vm.disabled
    },
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.update,
      "blur": _vm.touch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [(_vm.invalid && (_vm.customErrorMsg || _vm.errorMsg)) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.customErrorMsg || _vm.errorMsg) + "\n        ")]) : _c('span', {
    staticClass: "ghostly"
  }, [_vm._v("\n             \n        ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [(_vm.inspections.length || this.isAdmin) ? _c('div', {
    staticClass: "block"
  }, [_c('parcel-map', {
    ref: "parcelMap",
    staticClass: "map-container pullmeup full-width",
    staticStyle: {
      "height": "400px",
      "top": "0",
      "bottom": "0"
    },
    attrs: {
      "parcels": _vm.parcels,
      "centroids": _vm.centroids,
      "interactive": false,
      "allowDrawing": false
    },
    on: {
      "click": _vm.onClickFeature
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.inspections.length || this.isAdmin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search inspections"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInspections($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchInspections
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region_filter),
      expression: "region_filter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.region_filter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "al"
    }
  }, [_vm._v("Alabama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fl"
    }
  }, [_vm._v("Florida")])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status_filter),
      expression: "status_filter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status_filter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_submitted"
    }
  }, [_vm._v("Draft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "submitted"
    }
  }, [_vm._v("Submitted")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "validated"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rejected"
    }
  }, [_vm._v("Rejected")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "modified"
    }
  }, [_vm._v("Modified")])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.working) ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [(_vm.inspections.length || _vm.working || !_vm.isInspector) ? _c('div', [_c('div', {
    staticClass: "block-content",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', {
    staticClass: "inspection-table"
  }, [_c('inspection-list', {
    ref: "list",
    attrs: {
      "inspections": _vm.inspections,
      "columns": _vm.inspectionListColumns
    },
    on: {
      "deleteInspection": _vm.deleteInspectionCheck
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.inspections.length) ? _c('page-thingy', {
    attrs: {
      "count": _vm.inspectionDisplayCount,
      "page": _vm.inspectionDisplayPage_1base,
      "total": _vm.inspectionDisplayTotal
    },
    on: {
      "go": _vm.go
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "text-center text-muted",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('p', [_c('i', {
    staticClass: "icon-ghost",
    staticStyle: {
      "font-size": "100px"
    }
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("It looks like you haven't yet created an inspection.")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("Click below to get started!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    staticStyle: {
      "margin": "40px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newInspection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus push-5-r"
  }), _vm._v(" New Inspection\n                        ")]), _vm._v(" "), _c('p')])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.inspection.status.typename === 'not_submitted') ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("\n        DRAFT\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'submitted') ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("\n        SUBMITTED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'validated') ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n        APPROVED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'rejected') ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("\n        REJECTED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'modified') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("\n        MODIFIED\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mapboxMapDiv"
  })
},staticRenderFns: []}

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "visible-xs push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-create-inspector"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Forester\n    \t\t\t\t\t\t\t")])])])])])])]), _vm._v(" "), _c('div', {
    class: [(_vm.working) ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [_c('div', {
    staticClass: "block-content",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-vcenter table-clickable-rows"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Region")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inspectors), function(inspector) {
    return _c('tr', {
      on: {
        "click": function($event) {
          _vm.onRowClick($event.target, inspector)
        }
      }
    }, [_c('td', [_c('i', {
      staticClass: "icon-user text-muted"
    })]), _vm._v(" "), _c('td', {
      staticClass: "font-w600"
    }, [_c('router-link', {
      attrs: {
        "to": 'foresters/' + inspector.id
      }
    }, [_vm._v(_vm._s(inspector.user.contact.first_name) + " " + _vm._s(inspector.user.contact.last_name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.contact.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.contact.region.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(inspector.enabled) ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onInspectorDisable(inspector)
        }
      }
    }, [_vm._v("\n    \t\t\t\t\t\t\t\t\tDisable\n    \t\t\t\t\t\t\t\t")]) : _c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onInspectorEnable(inspector)
        }
      }
    }, [_vm._v("\n    \t\t\t\t\t\t\t\t\tEnable\n    \t\t\t\t\t\t\t\t")])])])
  }))])])])]), _vm._v(" "), _c('inspector-create-modal', {
    on: {
      "created": _vm.getInspectors
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-offset-2"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Contact Us\n                        "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-phone"
  }), _vm._v(" " + _vm._s(this.contactPhone))])])]), _vm._v(" "), (_vm.result === null) ? _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Got a question?")]), _vm._v("  Fill out the below form and we will get back to you as soon as we can.")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal push-30-t push-30",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.attempt($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('wc-input', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "First Name",
      "neverDirty": true
    },
    model: {
      value: (_vm.user.contact.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user.contact, "first_name", $$v)
      },
      expression: "user.contact.first_name"
    }
  }), _vm._v(" "), _c('wc-input', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Last Name",
      "neverDirty": true
    },
    model: {
      value: (_vm.user.contact.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user.contact, "last_name", $$v)
      },
      expression: "user.contact.last_name"
    }
  }), _vm._v(" "), _c('wc-input', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Email Address",
      "neverDirty": true
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('wc-input', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Phone Number",
      "neverDirty": true
    },
    model: {
      value: (_vm.user.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.user.contact, "phone", $$v)
      },
      expression: "user.contact.phone"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-12"
  }, [_vm._v("Message")]), _vm._v(" "), _c('wc-textarea', {
    staticClass: "col-sm-12",
    attrs: {
      "neverDirty": true
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendMessage($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope push-5-r"
  }), _vm._v(" Send")])])])])]) : (_vm.result === true) ? _c('div', {
    staticClass: "block-content block-content-full row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('h3', [_vm._v("Success!")]), _vm._v(" "), _c('div', {
    staticClass: "item item-2x item-circle bg-gray-lighter push-20-t push-20"
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake"
  })]), _vm._v(" "), _c('p', [_vm._v("Message received!  We will get back to you shortly. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "50px"
    }
  })]) : _c('div', {
    staticClass: "block-content block-content-full row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('div', {
    staticClass: "item item-2x item-circle bg-gray-lighter push-20-t push-20"
  }, [_c('i', {
    staticClass: "icon-ghost"
  })]), _vm._v(" "), _c('p', [_vm._v("We couldn't deliver your message.  Please reach out to us by calling " + _vm._s(this.contactPhone))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-footer"
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-create-inspector",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-popin"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-themed', 'block-transparent']
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("Fill out the following form in order to add a new forester.  Foresters are able to create new inspections and submit them for approval.  New foresters will receive and email with login information, including a randomly generated password.")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal push-10-t"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.first_name.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.first_name),
      expression: "inspector.user.contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.first_name)
    },
    on: {
      "blur": _vm.$v.inspector.user.contact.first_name.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "first_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Middle Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.middle_name),
      expression: "inspector.user.contact.middle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.middle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "middle_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.last_name.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.last_name),
      expression: "inspector.user.contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.last_name)
    },
    on: {
      "blur": _vm.$v.inspector.user.contact.last_name.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.inspector_license.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("ID#")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.inspector_license),
      expression: "inspector.inspector_license"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.inspector_license)
    },
    on: {
      "blur": _vm.$v.inspector.inspector_license.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector, "inspector_license", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.email.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.email),
      expression: "inspector.user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.inspector.user.email)
    },
    on: {
      "blur": _vm.$v.inspector.user.email.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user, "email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.phone),
      expression: "inspector.user.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "wcphone"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.company),
      expression: "inspector.user.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "company", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.address.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.address),
      expression: "inspector.user.contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.address)
    },
    on: {
      "blur": _vm.$v.inspector.user.contact.address.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "address", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.locality.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.locality),
      expression: "inspector.user.contact.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.locality)
    },
    on: {
      "blur": _vm.$v.inspector.user.contact.locality.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "locality", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.region_id.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "province"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.region_id),
      expression: "inspector.user.contact.region_id"
    }],
    staticClass: "form-control valid",
    on: {
      "blur": _vm.$v.inspector.user.contact.region_id.$touch,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inspector.user.contact, "region_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('option', {
      domProps: {
        "value": region.id
      }
    }, [_vm._v(_vm._s(region.name))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.inspector.user.contact.postal_code.$error
    }
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "postal_code"
    }
  }, [_vm._v("Zip Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.postal_code),
      expression: "inspector.user.contact.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.postal_code)
    },
    on: {
      "blur": _vm.$v.inspector.user.contact.postal_code.$touch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "postal_code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-primary",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n                                    Create Forester\n                                ")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "data-dismiss": "modal",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Create Forester")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])])
}]}

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image bg-trees full-height"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-rounded', 'animated', 'fadeIn', 'centered', 'login']
  }, [_c('div', {
    staticClass: "block-content block-content-full block-content-narrow"
  }, [_c('h1', {
    staticClass: "h2 font-w600 push-10-t push-20 text-center"
  }, [_c('img', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "src": __webpack_require__(373)
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal push-30-t push-30",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.attempt($event)
      }
    }
  }, [_c('wc-input', {
    attrs: {
      "label": "Email Address",
      "neverDirty": true
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password",
      "neverDirty": true,
      "silent": true
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-sm switch-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "remember"
    }
  }), _c('span'), _vm._v(" Remember Me?\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_token",
      "value": "Gs7rAgsTDA5eqhqQuGz90OR3XiYg4w8t0elDPRqh"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                Log in\n                            ")])])])], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inspections.length) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "64px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Inspection ID")]), _vm._v(" "), (_vm.showInspector) ? _c('th', [_vm._v("Forester Name")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Contact Name")]), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inspections), function(inspection) {
    return _c('tr', {
      attrs: {
        "data-id": inspection.id
      },
      on: {
        "click": function($event) {
          _vm.onRowClick($event.target, inspection)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspection.id))]), _vm._v(" "), (_vm.showInspector && inspection.inspector.user.contact.first_name) ? _c('td', [_vm._v(_vm._s(inspection.inspector.user.contact.first_name) + " " + _vm._s(inspection.inspector.user.contact.last_name))]) : (_vm.showInspector) ? _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]) : _vm._e(), _vm._v(" "), (inspection.contact.first_name) ? _c('td', [_vm._v(_vm._s(inspection.contact.first_name) + " " + _vm._s(inspection.contact.last_name))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), (inspection.region) ? _c('td', [_vm._v(_vm._s(inspection.region.abbr))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(inspection.created_at.date, 'YYYY/M/D - HH:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "status-badge-cell"
    }, [_c('inspection-status-badge', {
      attrs: {
        "inspection": inspection
      }
    })], 1), _vm._v(" "), (_vm.showDelete) ? _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteInspectionClick(inspection)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times push-5-r"
    }), _vm._v("Delete\n                    ")])]) : _vm._e()])
  }))])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "64px"
    }
  }, [_c('i', {
    staticClass: "icon-doc text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "text-center text-muted",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('p', [_c('i', {
    staticClass: "icon-ghost",
    staticStyle: {
      "font-size": "100px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("No inspections found.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel nulla ac risus aliquam pellentesque. Quisque posuere nunc augue, nec posuere quam elementum quis.")])])])
}]}

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push bg-trees"
  }, [_c('div', {
    staticClass: "bg-black-op"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "block block-transparent block-themed text-center"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('h1', {
    staticClass: "h1 font-w700 text-white animated fadeInDown push-5"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('h2', {
    staticClass: "h4 font-w400 text-white-op animated fadeInUp"
  }, [_vm._v("Welcome " + _vm._s(_vm.user.contact.first_name) + " " + _vm._s(_vm.user.contact.last_name))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingAdmin),
      expression: "isLeadingAdmin"
    }],
    staticClass: "row text-uppercase"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Placeholder")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary"
  }, [_vm._v("100")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Awaiting Approval | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-heart"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_submitted))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Post Modified | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('modified')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('modified')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_modified))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Not Yet Submitted | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_not_submitted))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingInspector),
      expression: "isLeadingInspector"
    }],
    staticClass: "row text-uppercase"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Rejected Submissions | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('rejected')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('rejected')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_rejected))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Incomplete Inspections | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_not_submitted))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded block-opt-refresh-icon8"
  }, [_c('div', {
    staticClass: "block-content block-content-full",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "inspection-table"
  }, [_c('inspection-list', {
    ref: "recentList",
    attrs: {
      "count": _vm.recentLength,
      "inspections": _vm.inspections,
      "columns": _vm.inspectionListColumns
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "font-w700 font-s15 text-gray-darker"
  }, [_vm._v("Export Inspections")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('wc-date', {
    attrs: {
      "label": "From",
      "neverDirty": true
    },
    model: {
      value: (_vm.exportStartDate),
      callback: function($$v) {
        _vm.exportStartDate = $$v
      },
      expression: "exportStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('wc-date', {
    attrs: {
      "label": "To",
      "neverDirty": true
    },
    model: {
      value: (_vm.exportEndDate),
      callback: function($$v) {
        _vm.exportEndDate = $$v
      },
      expression: "exportEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary pull-right",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportInspections
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" CSV\n                    ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('header', {
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_c('ul', {
    staticClass: "nav-header nav-pills pull-right hidden-xs",
    class: {
      'hidden-sm': _vm.isAdmin
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("\n                        Dashboard\n                    ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("\n                        Inspections\n                    ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v("\n                        Foresters\n                    ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                        Profile\n                    ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("\n                        Logout\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "hidden-sm",
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v("\n                        Help\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "visible-sm",
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-question-circle"
  })])], 1)]), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "nav-header nav-pills pull-right visible-sm"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-home"
  })])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-file"
  })])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-tree"
  })])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-question-circle"
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isInspector) ? _c('button', {
    staticClass: "btn btn-sm btn-success navbar-btn hidden-xs",
    staticStyle: {
      "margin": "2px 0 0 0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newInspection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus push-5-r"
  }), _vm._v(" New Inspection\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isInspector) ? _c('button', {
    staticClass: "btn btn-sm btn-success navbar-btn pull-right visible-xs",
    staticStyle: {
      "margin": "2px 0 0 0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newInspection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus push-5-r"
  }), _vm._v(" New Inspection\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav-header nav-pills pull-left"
  }, [_c('li', {
    staticClass: "header-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "text-logo"
  }, [_vm._v("CertPilot")]), _vm._v(" "), (_vm.isAdmin) ? _c('span', [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingAdmin),
      expression: "isLeadingAdmin"
    }],
    staticClass: "label label-success text-logo-label"
  }, [_vm._v("ADMINISTRATOR")])])], 1)])])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse remove-padding",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed visible-xs"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home push-5-r"
  }), _vm._v("\n                            Dashboard\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-file push-5-r"
  }), _vm._v("\n                            Inspections\n                        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree push-5-r"
  }), _vm._v("\n                            Foresters\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v("\n                            Profile\n                        ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out push-5-r"
  }), _vm._v("\n                            Logout\n                        ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle push-5-r"
  }), _vm._v("\n                            Help\n                        ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content content-boxed"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "bg-body font-s12",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed clearfix push-15"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "http://www.woodscamp.com",
      "target": "_blank"
    }
  }, [_vm._v("Woodscamp Technologies Inc.")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v(_vm._s(new Date().getFullYear()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "busy"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n                ")])])])
}]}

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [_c('div', {
    staticClass: "block-content block-content-full text-center bg-amethyst"
  }, [_c('div', {
    staticClass: "item item-2x item-circle bg-crystal-op push-20-t push-20"
  }, [_c('i', {
    staticClass: "icon-user text-white-op"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-white-op push-10"
  }, [_c('h4', [_vm._v(_vm._s(_vm.inspector.user.contact.first_name) + " " + _vm._s(_vm.inspector.user.contact.last_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-justified push-20",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab-profile-personal",
      "id": "personal-btn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTab('personal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  }), _vm._v(" Personal")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab-profile-password",
      "id": "password-btn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTab('password')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-asterisk"
  }), _vm._v(" Password")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "tab-profile-personal"
    }
  }, [_c('div', {
    staticClass: "form-horizontal push-10-t"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.first_name),
      expression: "inspector.user.contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("First Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.middle_name),
      expression: "inspector.user.contact.middle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.middle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "middle_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Middle Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.last_name),
      expression: "inspector.user.contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Last Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.inspector_license),
      expression: "inspector.inspector_license"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.inspector_license)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector, "inspector_license", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("ID#")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.email),
      expression: "inspector.user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.inspector.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Email")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.phone),
      expression: "inspector.user.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Phone")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.address),
      expression: "inspector.user.contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inspector.user.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspector.user.contact, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Address")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspector.user.contact.region_id),
      expression: "inspector.user.contact.region_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inspector.user.contact, "region_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('option', {
      domProps: {
        "value": region.id
      }
    }, [_vm._v(_vm._s(region.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "text-muted"
  }, [_vm._v("State")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tab-profile-password"
    }
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-sm-12 form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.password.$error
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "profile-password-new"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }, function($event) {
        _vm.$v.password.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.password.minLength) ? _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [_vm._v("Password must have at least " + _vm._s(_vm.$v.password.$params.minLength.min) + " letters.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.$v.repeatPassword.$error
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "profile-password-new-confirm"
    }
  }, [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.repeatPassword),
      expression: "repeatPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value.trim()
      }, function($event) {
        _vm.$v.repeatPassword.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.repeatPassword.sameAsPassword) ? _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateInspector($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check push-5-r"
  }), _vm._v(" Save Changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Inspections")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full"
  }, [(_vm.inspector.inspections.data.length > 0) ? _c('div', [_c('table', {
    staticClass: "table table-hover table-vcenter table-clickable-rows"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "64px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Inspection ID")]), _vm._v(" "), _c('th', [_vm._v("Contact Name")]), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inspector.inspections.data), function(inspection) {
    return _c('tr', {
      attrs: {
        "data-id": inspection.id
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: '/inspections/' + inspection.id
          })
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "64px"
      }
    }, [_c('i', {
      staticClass: "icon-doc text-muted"
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspection.id))]), _vm._v(" "), (inspection.contact.first_name) ? _c('td', [_vm._v(_vm._s(inspection.contact.first_name) + " " + _vm._s(inspection.contact.last_name))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), (inspection.region) ? _c('td', [_vm._v(_vm._s(inspection.region.abbr))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), _c('td', {
      staticClass: "status-badge-cell"
    }, [_c('inspection-status-badge', {
      attrs: {
        "inspection": inspection
      }
    })], 1)])
  }))])]) : _c('div', [_c('div', {
    staticClass: "text-center text-muted"
  }, [_c('div', {
    staticClass: "item item-2x item-circle bg-gray-lighter push-20-t push-20"
  }, [_c('i', {
    staticClass: "icon-ghost"
  })]), _vm._v(" "), _c('p', [_vm._v("Forester currently has no inspections. ")])])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination pagination-sm"
  }, [_c('li', {
    class: {
      'disabled': _vm.page === 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.page - 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._l((_vm.pages), function(p) {
    return _c('li', {
      class: {
        'active': _vm.page === p
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.go(p)
        }
      }
    }, [_vm._v(_vm._s(p))])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.page === _vm.pages.length
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.page + 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    }
  }, [(_vm.label) ? _c('label', {}, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', [_c('date-picker', {
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    },
    attrs: {
      "config": _vm.config,
      "disabled": _vm.disabled
    },
    on: {
      "dp-change": _vm.update
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [(_vm.invalid && (_vm.customErrorMsg || _vm.errorMsg)) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.customErrorMsg || _vm.errorMsg) + "\n        ")]) : _c('span', {
    staticClass: "ghostly"
  }, [_vm._v("\n             \n        ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 831:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('main', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./inspection-default1-published.vue": [
		374,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 866;

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./inspection-default1-published.vue": [
		374,
		0
	],
	"./inspection-default1.vue": [
		888,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 867;

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(363);
module.exports = __webpack_require__(362);


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.f33df36.eot";

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Simple-Line-Icons.2fe2efe.svg";

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/trees.2fd252c.jpg";

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.d228596.ttf";

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.0cb0b9c.woff2";

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.78f07e2.woff";

/***/ })

},[868]);


// WEBPACK FOOTER //
// static/js/app.599ef4dbe69202eacb18.js